/* ============================================================================
FILE: po-esthetique-multiple-pluriel-texts-fr-en-es-20260331.js
MODE: manual FR/EN/ES switch + lexicon protection + exact French body
API:  window.PoEsthetiqueMultiplePlurielFR_EN_ES_20260331
ROOT: .po-axis-section[data-po-essay="multiple_pluriel"]
ROLE:
  - Injecte la page complète “L’esthétique du Multiple-pluriel”.
  - Protège le bloc des traductions externes.
  - Garde le lexique canonique en français.
  - Bascule FR / EN / ES pour l’interface, la navigation, les légendes et les titres structurels.
  - Conserve le corps long exact du document source en français pour préserver la rédaction.
============================================================================= */
(function(){
  "use strict";

  if (window.__PO_ESTHETIQUE_MULTIPLE_PLURIEL_20260331__) return;
  window.__PO_ESTHETIQUE_MULTIPLE_PLURIEL_20260331__ = true;

  var STORAGE_KEY = "po_mp_lang";
  var LEXICON_FALLBACK_URL = "https://goodyart.store/pages/lexique-simplifie/";
  var TITLE_IMG_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Multiple-pluriel.png?v=1774982917";
  var SUPERPOSITION_PERSPECTIVES_PAGE_URL = "https://goodyart.store/pages/superposition-de-perspectives";
  var SUPERPOSITION_PERSPECTIVES_IMG_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Supperposition_de_perspective_2.png?v=1746214790";
  var POSOENNOISME_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Posoennoisme_conceptuel.png?v=1774147883";
  var SUJET_PLURIEL_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sujet_pluriel_2.png?v=1746214788";
  var ADDITION_SYNCHRETIQUE_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Addition_Synchretique.png?v=1769951779";
  var INSTANTANE_MULTIPLE_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Instantane_mutiple_2.png?v=1746214804";
  var ARTICLE_2001_IMG_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/DP_article_Multiple_pluriel.jpg?v=1783565958";
  var ARTICLE_2001 = {
    "fr": {
      "modal_title": "Document 10 — Les « multiple-pluriel » de Goodÿ",
      "article_title": "Les « multiple-pluriel » de Goodÿ",
      "source": "France-Antilles Magazine Guadeloupe — semaine du 9 au 15 juin 2001.",
      "open_label": "Lire l’article de 2001",
      "image_alt": "Article de presse de 2001 sur Multiple-pluriel",
      "trigger_label": "Cliquer sur l’article pour lire le texte",
      "close_label": "Fermer l’article",
      "paras": [
        "Exposition",
        "Goodÿ est l’un de ces jeunes plasticiens qui, quoique peu connus, ont déjà une empreinte, un coup de pinceau qui attire l’œil, voire qui intrigue.",
        "La peinture de Goodÿ, très colorée et rafraîchissante apporte une petite pointe de gaieté dans un intérieur. Pourtant, au-delà de ces premières impressions, ces toiles inspirent un sentiment beaucoup plus vaste, beaucoup plus profond.",
        "« L’artiste a un devoir d’éducation vis-à-vis du public, affirme Goodÿ. Sa conception de son travail doit toucher des domaines beaucoup plus vastes que les besoins primaires, en suscitant une réflexion profonde. »",
        "Le travail de Goodÿ découle d’une peinture qu’on pourrait qualifier de sociologique. Pour preuve, sa première exposition individuelle, qui se déroulera jusqu’au 16 juin au Centre des arts de Pointe-à-Pitre, est une succession de regards sur la ville, sur ce qui nous entoure, sur nos lieux de vie… Le tout, pour le peintre, étant de nous amener à nous interroger sur les relations et les éventuelles influences du lieu où on vit, sur notre personnalité.",
        "« Multiple-pluriel va dans le sens d’une recherche d’identité, explique Goodÿ. C’est une façon d’évoquer à la fois ce métissage biologique et culturel, qui va aussi dans le sens de la recherche identitaire. Je crée une multiplicité d’émotions et j’exprime une même émotion de manières différentes. De même, au sein d’une société, on retrouve des expressions plurielles. Multiple-pluriel est un appel à plus de tolérance. Le tout étant de se dire que de la diversité, naît l’unité : il y a plusieurs voies pour atteindre un même objectif et plusieurs façons d’exprimer une même idée. »",
        "« Dis-moi où tu vis, je te dirai qui tu es »",
        "À travers ses œuvres, Goodÿ établit un lien entre les grandes villes internationales et les cités du département, en soulevant un problème autrement plus intéressant, relatif à l’influence des quartiers-ghettos sur leurs habitants, une interaction semblable au « Dis-moi où tu vis, je te dirai qui tu es. »",
        "Successivement animateur puis assistant en arts plastiques à l’Espace Chadru, Goodÿ flirte avec le milieu artistique depuis 15 ans, par le biais du dessin. Récemment, il a succombé à l’attrait de la peinture.",
        "« Le travail de peinture n’a rien à voir avec le dessin. Maintenant, avec la peinture, j’ai la possibilité d’exprimer tout ce qui sort de l’intérieur, des émotions pures. L’idée pour moi est de transposer, à travers ma peinture, le désordre architectural et l’évolution de la société. »",
        "Cécilia Larney.",
        "Encadré : 6 A pour les artistes",
        "Depuis peu, à l’initiative de six peintres du département, Goodÿ, Ano, Stonko, Roquelaure, Hébert Edau, l’association 6A, présidée par Antoine Nabajoth, se propose de mettre en place une véritable structure destinée aux plasticiens. Elle permettra d’organiser et de développer la profession en Guadeloupe, tout en offrant un point de repères aux personnes, aux institutions et autres associations qui souhaitent prendre contact avec les plasticiens du département.",
        "Association 6A : 0590 55 40 49 — 0590 50 39 58."
      ]
    },
    "en": {
      "modal_title": "Document 10 — The “multiple-pluriel” of Goodÿ",
      "article_title": "The “multiple-pluriel” of Goodÿ",
      "source": "France-Antilles Magazine Guadeloupe — week of June 9 to 15, 2001.",
      "open_label": "Read the 2001 article",
      "image_alt": "2001 press article on Multiple-pluriel",
      "trigger_label": "Click the article to read the text",
      "close_label": "Close the article",
      "paras": [
        "Exhibition",
        "Goodÿ is one of those young visual artists who, although still little known, already have a distinctive mark, a brushstroke that catches the eye, even intrigues it.",
        "Goodÿ’s painting, very colorful and refreshing, brings a small touch of brightness into an interior. Yet beyond these first impressions, his canvases inspire a much broader, much deeper feeling.",
        "“The artist has an educational duty toward the public,” Goodÿ states. “His conception of his work must touch fields much broader than primary needs, by prompting deep reflection.”",
        "Goodÿ’s work arises from a kind of painting one might describe as sociological. As proof, his first solo exhibition, running until June 16 at the Centre des arts in Pointe-à-Pitre, unfolds as a succession of views of the city, of what surrounds us, of our living spaces… For the painter, the point is to lead us to question the relationships and possible influences of the place where we live on our personality.",
        "“Multiple-pluriel moves in the direction of a search for identity,” Goodÿ explains. “It is a way of evoking both biological and cultural métissage, which also points toward the search for identity. I create a multiplicity of emotions and express the same emotion in different ways. Likewise, within a society, we find plural expressions. Multiple-pluriel is a call for greater tolerance. The point is to say that unity is born from diversity: there are several paths to reach the same objective and several ways to express the same idea.”",
        "“Tell me where you live, and I will tell you who you are”",
        "Through his works, Goodÿ establishes a link between major international cities and the towns of the department, raising a much more interesting issue concerning the influence of ghetto districts on their inhabitants, an interaction similar to “Tell me where you live, and I will tell you who you are.”",
        "Having worked successively as an animator and then as an assistant in visual arts at Espace Chadru, Goodÿ has been close to the artistic milieu for 15 years through drawing. Recently, he yielded to the attraction of painting.",
        "“Painting has nothing to do with drawing. Now, with painting, I have the possibility of expressing everything that comes from within, pure emotions. My idea is to transpose, through my painting, architectural disorder and the evolution of society.”",
        "Cécilia Larney.",
        "Inset: 6 A for artists",
        "Recently, at the initiative of six painters from the department — Goodÿ, Ano, Stonko, Roquelaure, Hébert Edau — the association 6A, chaired by Antoine Nabajoth, set itself the task of establishing a genuine structure for visual artists. It will make it possible to organize and develop the profession in Guadeloupe, while offering a point of reference for people, institutions and other associations wishing to contact visual artists in the department.",
        "Association 6A: 0590 55 40 49 — 0590 50 39 58."
      ]
    },
    "es": {
      "modal_title": "Documento 10 — Los “multiple-pluriel” de Goodÿ",
      "article_title": "Los “multiple-pluriel” de Goodÿ",
      "source": "France-Antilles Magazine Guadeloupe — semana del 9 al 15 de junio de 2001.",
      "open_label": "Leer el artículo de 2001",
      "image_alt": "Artículo de prensa de 2001 sobre Multiple-pluriel",
      "trigger_label": "Haz clic en el artículo para leer el texto",
      "close_label": "Cerrar el artículo",
      "paras": [
        "Exposición",
        "Goodÿ es uno de esos jóvenes artistas plásticos que, aunque todavía poco conocidos, ya poseen una huella, una pincelada que atrae la mirada, incluso que intriga.",
        "La pintura de Goodÿ, muy colorida y refrescante, aporta una pequeña nota de alegría a un interior. Sin embargo, más allá de esas primeras impresiones, sus lienzos inspiran un sentimiento mucho más vasto, mucho más profundo.",
        "“El artista tiene un deber de educación frente al público”, afirma Goodÿ. “Su concepción de su trabajo debe tocar ámbitos mucho más amplios que las necesidades primarias, suscitando una reflexión profunda.”",
        "El trabajo de Goodÿ procede de una pintura que podría calificarse de sociológica. Prueba de ello es que su primera exposición individual, que se desarrollará hasta el 16 de junio en el Centre des arts de Pointe-à-Pitre, es una sucesión de miradas sobre la ciudad, sobre lo que nos rodea, sobre nuestros lugares de vida… Para el pintor, se trata de llevarnos a interrogarnos sobre las relaciones y las posibles influencias del lugar donde vivimos sobre nuestra personalidad.",
        "“Multiple-pluriel va en el sentido de una búsqueda de identidad”, explica Goodÿ. “Es una manera de evocar a la vez ese mestizaje biológico y cultural, que también va en el sentido de la búsqueda identitaria. Creo una multiplicidad de emociones y expreso una misma emoción de maneras diferentes. Del mismo modo, dentro de una sociedad encontramos expresiones plurales. Multiple-pluriel es un llamado a una mayor tolerancia. Se trata de decir que de la diversidad nace la unidad: hay varias vías para alcanzar un mismo objetivo y varias maneras de expresar una misma idea.”",
        "“Dime dónde vives y te diré quién eres”",
        "A través de sus obras, Goodÿ establece un vínculo entre las grandes ciudades internacionales y las ciudades del departamento, planteando un problema aún más interesante, relativo a la influencia de los barrios-guetos sobre sus habitantes, una interacción semejante al “Dime dónde vives y te diré quién eres”.",
        "Sucesivamente animador y luego asistente en artes plásticas en el Espace Chadru, Goodÿ coquetea con el medio artístico desde hace 15 años, a través del dibujo. Recientemente, sucumbió al atractivo de la pintura.",
        "“El trabajo de la pintura no tiene nada que ver con el dibujo. Ahora, con la pintura, tengo la posibilidad de expresar todo lo que sale del interior, emociones puras. Para mí, la idea es transponer, a través de mi pintura, el desorden arquitectónico y la evolución de la sociedad.”",
        "Cécilia Larney.",
        "Recuadro: 6 A para los artistas",
        "Desde hace poco, por iniciativa de seis pintores del departamento — Goodÿ, Ano, Stonko, Roquelaure, Hébert Edau —, la asociación 6A, presidida por Antoine Nabajoth, se propone establecer una verdadera estructura destinada a los artistas plásticos. Permitirá organizar y desarrollar la profesión en Guadalupe, ofreciendo al mismo tiempo un punto de referencia a las personas, instituciones y otras asociaciones que deseen ponerse en contacto con los artistas plásticos del departamento.",
        "Asociación 6A: 0590 55 40 49 — 0590 50 39 58."
      ]
    }
  };

  function svgDataUri(label){
    var svg = '' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">' +
      '<rect width="200" height="200" rx="28" fill="rgba(255,255,255,0)"/>' +
      '<circle cx="76" cy="100" r="42" fill="none" stroke="#b8860b" stroke-width="8"/>' +
      '<circle cx="124" cy="100" r="42" fill="none" stroke="#1f7a3a" stroke-width="8"/>' +
      '<circle cx="100" cy="76" r="42" fill="none" stroke="#ffffff" stroke-opacity="0.8" stroke-width="8"/>' +
      '<text x="100" y="176" text-anchor="middle" font-family="Georgia, serif" font-size="18" fill="#f4f0e8">' + label + '</text>' +
      '</svg>';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  function safeImageUrl(src, fallbackLabel){
    return { src: src, fallback: svgDataUri(fallbackLabel || 'Idéogramme') };
  }

  function clampStr(v){ return v == null ? "" : String(v); }
  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    if (s.indexOf("en") === 0) return "en";
    return "fr";
  }
  function getStoredLang(){
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      return v ? normLang(v) : "";
    } catch(e){ return ""; }
  }
  function setStoredLang(lang){
    try { localStorage.setItem(STORAGE_KEY, normLang(lang)); } catch(e){}
  }
  function detectLang(){
    var stored = getStoredLang();
    if (stored) return stored;
    var dl = document.documentElement.getAttribute("lang") || "";
    if (dl) return normLang(dl);
    if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0]);
    if (navigator.language) return normLang(navigator.language);
    return "fr";
  }
  function slugify(str){
    return clampStr(str)
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/œ/g, "oe")
      .replace(/æ/g, "ae")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  var PAGE_DATA = {
  "front": {
    "title": "L’esthétique du Multiple-pluriel",
    "subtitle": "Anamnèse conceptuelle, lecture posœnnoïale et définition générale",
    "doclabel": "Document de présentation générale",
    "author": "Goodÿ – Gilles EUGENE",
    "works_caption": "De gauche à droite : « Renaissance », Méfyans, Synchét’Isme.",
    "rights": "Tous concepts, textes et œuvres du Posœnnoïsme : propriété intellectuelle de Goodÿ – Gilles EUGENE (© ADAGP Paris 2024)."
  },
  "quote": "« Je suis cette zone de contact entre le contour de la forme et l’autour qui constitue l’espace où s’exprime la forme. Je suis cet espace, de frictions, de tensions, de douceurs, de fusions, de chocs et d’éloignements, qui donne à l’œuvre sa dimension poétique. Je suis un concentré du monde où résonnent tant de mondes, de cultures, d’histoires et d’affects : une unité hétérogène de la singularité, une expression plurielle du multiple dans un monde en perpétuelle mutation. »",
  "quote_source": "Goodÿ – Gilles EUGENE, Ordo Ab Chaos, 2015",
  "sections": [
    {
      "title_fr": "Préambule méthodologique",
      "intro": [
        {
          "style": "Body Custom",
          "text": "Le présent document propose une formulation ample d’un concept déjà actif dans l’œuvre, dans les écrits et dans l’architecture posœnnoïale, mais encore distribué entre plusieurs foyers d’énonciation. La démarche procède par anamnèse des mots communs mobilisés par le concept, selon une remontée ordonnée : depuis les usages contemporains vers les racines les plus anciennes accessibles, puis depuis ces racines vers la densité conceptuelle requise par le Posœnnoïsme. L’enjeu relève d’un double geste. D’une part, retrouver la charge originaire des mots esthétique, multiple et pluriel. D’autre part, éprouver la manière dont ces mots, réaccordés à la matière des œuvres et à la cohérence de l’Organon posœnnoïal, deviennent capables de nommer une logique formelle, perceptive, poïétique, philosophique et vibratoire déjà à l’œuvre dans les peintures, les concepts opératifs et la structure générale du système."
        },
        {
          "style": "Body Custom",
          "text": "Cette démarche demande une précision particulière. Les mots du langage courant gardent ici leur histoire propre ; ils entrent dans une anamnèse, retrouvent leur fond ancien, leur mémoire active et leur tenseur symbolique. Il s’agit donc d’un travail de densification du sens, porté par le fil du corpus, par la matière plastique des œuvres et par la cohérence interne du lexique. Une autre exigence traverse l’ensemble : l’œuvre tient en elle une résonance du tout, alors que sa réception dépend de la liberté d’esprit, du capital culturel, de l’expérience de vie et de la posture du regardeur face à ce qui se présente. Le problème ne relève donc pas d’un « chacun voit ce qu’il veut », formule trop lâche pour une pensée exigeante du sensible ; il relève d’un « chacun voit ce qu’il peut », selon l’amplitude intérieure disponible, la qualité d’attention, la mémoire symbolique et la capacité d’entrer dans la densité de l’œuvre."
        }
      ],
      "subsections": []
    },
    {
      "title_fr": "I. Pourquoi le Multiple-pluriel appelle aujourd’hui une formulation explicite",
      "intro": [
        {
          "style": "Body Custom",
          "text": "Le Multiple-pluriel apparaît déjà comme un foyer profond de la pensée posœnnoïale, de la peinture de Goodÿ et du langage qui les accompagne. Il traverse la phrase inaugurale d’Ordo Ab Chaos, affleure dans l’introduction d’Axis, travaille la logique du Sujet pluriel, de l’Instantané multiple, de l’Addition synchrêtique et de la Superposition de perspectives, innerve encore les Modalités opératives lorsqu’elles se présentent comme vecteurs d’expression du multiple-pluriel de nos réalités. Une telle récurrence désigne davantage qu’un simple motif lexical. Elle indique la présence d’un centre de gravité."
        },
        {
          "style": "Body Custom",
          "text": "Cette présence demeurait jusqu’ici en régime d’évidence diffuse. Le corpus la faisait agir. Les œuvres la faisaient sentir. Le regardeur y entrait par l’expérience de la forme, du heurt, de la superposition, de l’émergence, de l’apparition inachevée, de la figure en cours de recomposition. Or la réception d’une telle œuvre demande toujours une disponibilité particulière. Elle dépend d’une liberté intérieure, d’une culture du regard, d’une mémoire des formes, d’une expérience du trouble, d’une capacité à demeurer devant l’œuvre sans réduire trop vite ce qui s’y présente. La justesse de lecture relève donc moins d’une volonté arbitraire que d’une puissance d’accueil. L’œuvre résonne plus large que ce que chaque regard peut y saisir d’emblée."
        },
        {
          "style": "Body Custom",
          "text": "Cette formulation explicite accomplit plusieurs fonctions à la fois. Elle clarifie d’abord la singularité de cette pensée dans le champ des pratiques de la multiplicité. Elle distingue ensuite cette démarche de la simple diversité, de l’éclectisme voisinant les formes sans nécessité interne, du fragmentaire livré à lui-même, du syncrétisme compris comme fusion indifférenciée, ou encore d’une pluralité purement sociologique. Elle ouvre aussi une voie de lecture plus fine des œuvres : la peinture cesse d’y être reçue comme amas d’éléments hétérogènes, elle apparaît comme orchestration exigeante de présences, de strates, d’affects, de devenirs et de seuils. Enfin, elle donne au Posœnnoïsme un terme-charnière supplémentaire, situé à l’endroit même où l’esthétique, l’ontologie, la perception, la mémoire et la relation se rejoignent."
        },
        {
          "style": "Body Custom",
          "text": "Le moment atteint par le champ posœnnoïal rend cette nomination particulièrement juste. La structure générale du système existe déjà. Les grands piliers, les outils, les engrenages, les modalités, les pratiques, les univers et la matrice possèdent leurs foyers d’écriture. À ce stade, une notion telle que le Multiple-pluriel gagne à recevoir un document à part entière, capable d’en dégager la nécessité, la profondeur, le régime d’usage et la portée. Ce texte se présente donc comme une fondation écrite, ample, destinée à préparer une stabilisation plus resserrée dans les lexiques, les présentations générales et les lectures futures."
        }
      ],
      "subsections": []
    },
    {
      "title_fr": "II. Anamnèse du mot « esthétique »",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. Du sentir à la forme sensible",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le mot esthétique remonte à la famille grecque d’aísthêsis, qui renvoie au sentir, à la perception par les sens, à la faculté de recevoir le monde sous forme de sensation. Le terme a d’abord partie liée avec la venue du monde dans la chair perceptive, avec la manière dont un être reçoit, éprouve, distingue, subit, accueille ou intensifie la présence. Cette généalogie donne tout de suite une orientation décisive : l’esthétique, dans sa racine la plus ancienne, relève d’un champ sensoriel, perceptif, vécu, avant de relever du jugement de goût au sens tardif."
            },
            {
              "style": "Body Custom",
              "text": "Le grec aisthêtikos, puis le latin philosophique aesthetica, ont ensuite déplacé cet horizon vers une science ou une théorie du sensible. L’histoire moderne de la discipline a souvent serré le terme autour du beau, de l’art, du goût, du jugement et de la forme réussie. Cette histoire garde sa valeur. Elle demeure pourtant plus étroite que la racine. L’œuvre de Goodÿ appelle justement une réouverture du mot à sa profondeur initiale."
            },
            {
              "style": "Body Custom",
              "text": "Dans la pensée ici engagée, l’esthétique désigne beaucoup plus qu’un ensemble de qualités plastiques agréables ou puissantes. Elle devient un régime de manifestation sensible, une architecture de l’apparition, une manière de faire venir à la perception ce qui, dans le monde, demeure d’ordinaire latent, stratifié, contradictoire, vibrant, encore inachevé. L’esthétique relève alors de l’organisation de l’apparaître. Elle concerne la manière dont une œuvre rend sensible la densité d’un réel traversé de plusieurs niveaux de présence."
            }
          ]
        },
        {
          "title_fr": "2. Le retour posœnnoïal à l’aísthêsis",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Une lecture posœnnoïale du terme retrouve ainsi son amplitude primitive tout en l’intensifiant. L’esthétique devient la chambre de perception où le visible, l’invisible, la mémoire, le seuil, l’affect, la relation et la pensée s’ajustent dans une même venue sensible. Une œuvre porte une esthétique lorsque le sensible s’y organise selon une nécessité interne, lorsqu’une forme y devient le lieu d’un passage, d’une modulation, d’une tension réglée, d’une densification du sentir."
            },
            {
              "style": "Body Custom",
              "text": "Dans cette perspective, parler d’une esthétique du Multiple-pluriel revient à parler d’une manière spécifique de faire advenir le monde au sentir. Il s’agit d’un monde stratifié, traversé de voix, de plans, de cultures, de temporalités, d’affects, de fragments, de contradictions et d’élans, que l’œuvre fait tenir ensemble dans un champ de perception partageable. Le partage, toutefois, ne signifie jamais saisie égale pour tous. Une œuvre du Multiple-pluriel offre davantage qu’elle ne livre d’emblée ; elle appelle un regard disponible, assez libre pour soutenir l’écart, assez cultivé pour reconnaître certaines strates, assez vivant pour accueillir ce qui excède son savoir."
            }
          ]
        },
        {
          "title_fr": "3. Première conséquence conceptuelle",
          "paras": [
            {
              "style": "Body Custom",
              "text": "L’expression « esthétique du Multiple-pluriel » demande donc déjà une précision. Elle ne renvoie pas d’abord à un thème, encore moins à un décor de la diversité. Elle désigne un mode d’apparition du monde et un régime de réception du sensible. Elle nomme la manière dont une œuvre fait sentir la coexistence active d’une pluralité de formes, de temps, de régimes de présence et d’intensités, par une organisation sensible assez forte pour offrir une unité, assez ouverte pour garder les écarts vivants."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "III. Anamnèse du mot « multiple »",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. Le multiple comme plissement",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le mot multiple vient du latin multiplex. Sa racine ouvre une profondeur très précieuse au concept. Multiplex signifie littéralement ce qui comporte plusieurs plis, plusieurs replis, plusieurs couches entremêlées. À l’origine, le multiple possède donc une dimension textile, structurale, presque topologique. Il porte l’idée d’un ensemble tissé, plié, composé, entrelacé. Avant la simple quantité, il y a le plissement."
            },
            {
              "style": "Body Custom",
              "text": "Cette mémoire du pli change radicalement la portée du mot. Le multiple cesse d’apparaître comme une simple série d’unités juxtaposées. Il entre dans le champ de la complexité organisée. Il devient ce qui contient plusieurs couches en relation, plusieurs lignes d’inscription, plusieurs surfaces repliées les unes dans les autres, plusieurs axes de lecture travaillant simultanément une même forme."
            },
            {
              "style": "Body Custom",
              "text": "La peinture de Goodÿ accueille admirablement cette profondeur. Les figures y apparaissent comme des corps de plis, de replis, d’incurvations, de membranes, de torsions, de trames, de seuils internes, d’émergences contrariées. Le multiple y relève bien d’une dynamique de feuilletage. Une forme ne s’y donne jamais comme bloc simple ; elle advient comme résultat provisoire d’un ensemble de strates qui s’appellent, se frottent, se masquent, se révèlent, se traversent et se relancent."
            }
          ]
        },
        {
          "title_fr": "2. Le multiple comme densité stratifiée",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Ce retour au pli donne au mot une fonction bien plus riche. Le multiple devient le nom d’une densité stratifiée du réel. Il désigne un monde où toute forme comporte plusieurs niveaux d’inscription, où toute présence garde la mémoire d’autres présences, où un contour se trouve travaillé par un dehors, où une image contient déjà plusieurs devenirs."
            },
            {
              "style": "Body Custom",
              "text": "Dans le champ posœnnoïal, cette densité stratifiée entre en résonance avec plusieurs lieux majeurs. L’Instantané multiple capte la simultanéité de plusieurs temps et de plusieurs points de vue à l’intérieur d’un même instant. La Stratification d’expériences donne au vécu une épaisseur de couches réinterprétables. L’Expérience fragmentée maintient des noyaux discontinus comme matières de recomposition. La Temporalité éclatée accueille les collisions temporelles. Le multiple s’y présente donc comme un régime du vécu autant que comme un régime de la forme."
            }
          ]
        },
        {
          "title_fr": "3. Le multiple comme réserve opérative",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le multiple, dans le Posœnnoïsme, garde encore une fonction énergétique. Il représente la réserve des matériaux, des apports, des intensités, des écarts, des héritages, des seuils, des imaginaires et des tensions que la pensée et la création reçoivent, brassent, densifient et font circuler. L’engrenage posœnnoïaque en porte une part essentielle, par son mouvement d’accumulation, de collecte, d’épaississement, de brassage. Le multiple correspond alors à la richesse du champ, à son amplitude de matériaux, à l’ouverture des prises."
            },
            {
              "style": "Body Custom",
              "text": "Cette réserve, toutefois, demande une forme de tenue. Faute de quoi, le multiple se répandrait en dispersion pure. L’anamnèse du mot éclaire justement le besoin d’une articulation supplémentaire. Un monde à plusieurs plis appelle une pensée de la relation entre les plis. C’est ici que le pluriel entre en scène."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "IV. Anamnèse du mot « pluriel »",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. De la grammaire à l’ontologie des présences",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le mot pluriel vient du latin pluralis. L’histoire grammaticale du terme indique d’abord le nombre supérieur à un, l’accord de plusieurs unités, la marque d’une pluralité. Cette origine pourrait sembler plus pauvre que celle du multiple. En réalité, elle apporte une précision décisive. Le pluriel relève de la présence de plusieurs sujets, plusieurs entités, plusieurs voix ou plusieurs éléments tenus dans un même régime d’énonciation."
            },
            {
              "style": "Body Custom",
              "text": "Là où le multiple insiste sur la stratification, le pli, la densité composée, le pluriel insiste sur l’existence simultanée de plusieurs foyers distincts. Il garde donc une portée qualitative. Il annonce la coexistence de singularités, l’affirmation de plusieurs centres de présence, la coprésence de plusieurs régimes d’énonciation. Le pluriel donne un statut aux différences."
            },
            {
              "style": "Body Custom",
              "text": "Dans le langage ordinaire, le pluriel demeure souvent cantonné à la grammaire. Dans la pensée posœnnoïale, il gagne une portée anthropologique, perceptive, relationnelle et ontologique. Le Sujet pluriel en constitue l’expression la plus nette. Le sujet y apparaît comme assemblage dynamique d’expériences, de souvenirs, de projections, de voix, de seuils intérieurs, de mémoires et d’affects en relation. Le pluriel cesse alors d’indiquer seulement un nombre ; il devient une forme d’être."
            }
          ]
        },
        {
          "title_fr": "2. Le pluriel comme irréductibilité des voix",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le pluriel apporte au concept une exigence forte : l’irréductibilité des présences. Plusieurs plans peuvent cohabiter, plusieurs voix peuvent se répondre, plusieurs mémoires peuvent traverser une œuvre, plusieurs héritages peuvent entrer en composition, tout en gardant leurs contours propres. Le pluriel interdit l’homogénéisation absolue. Il garantit que la composition reste habitée par des singularités distinctes."
            },
            {
              "style": "Body Custom",
              "text": "Cette garantie revêt une grande importance dans l’univers posœnnoïal. L’Addition synchrêtique, par exemple, intègre des éléments culturels, philosophiques et artistiques sans les uniformiser. La Superposition de perspectives tient ensemble plusieurs angles. Aliœvolution fait de l’altérité un moteur de transformation sans dissoudre l’ancrage. RéZonans relie sans annuler les intensités propres. Le pluriel donne à tous ces mouvements leur exigence éthique : chaque apport demeure porteur de sa vibration particulière."
            }
          ]
        },
        {
          "title_fr": "3. Le pluriel comme mode d’habitation",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le pluriel devient ainsi un mode d’habitation du monde. Habiter le pluriel, dans une perspective posœnnoïale, consiste à accueillir plusieurs centres de sens, plusieurs mémoires, plusieurs héritages, plusieurs voies d’apparition et plusieurs régimes de vérité sensible, dans une même architecture vivante. Une telle habitation appelle une intelligence de la relation, une tenue intérieure, un sens des passages, une capacité d’accordage."
            },
            {
              "style": "Body Custom",
              "text": "Dans l’œuvre peinte, cela se traduit par des formes qui gardent plusieurs identités possibles, plusieurs devenirs figuraux, plusieurs lectures simultanées. Dans la pensée, cela se traduit par une architecture ouverte, capable de lier art, philosophie, symbolique, religion, ésotérisme, anthropologie, mémoire diasporique, histoire de l’art et expérience vécue. Dans la vie même, cela ouvre une anthropologie du sujet complexe, relationnel, stratifié et transformable."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "V. Du voisinage des mots au concept : naissance du « Multiple-pluriel »",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. Pourquoi l’association des deux termes devient nécessaire",
          "paras": [
            {
              "style": "Body Custom",
              "text": "L’union de multiple et de pluriel produit une intensification réciproque. Le multiple apporte la profondeur des plis, des strates, des chevauchements, des densités et des entrelacements. Le pluriel apporte la présence de plusieurs foyers distincts, plusieurs voix, plusieurs singularités, plusieurs régimes d’être. Ensemble, ils composent un concept capable de nommer une réalité plus fine que chacune des deux notions prise isolément."
            },
            {
              "style": "Body Custom",
              "text": "Le Multiple-pluriel désigne alors un champ où plusieurs couches, plusieurs temps, plusieurs mémoires, plusieurs formes, plusieurs voix et plusieurs régimes de présence coexistent, s’interpénètrent, se modulent et se relancent, tout en gardant leur différenciation active. Le concept atteint ici une qualité rare. Il permet de penser à la fois la structure interne de la complexité et l’irréductibilité des singularités qui l’habitent."
            }
          ]
        },
        {
          "title_fr": "2. Le trait d’union comme opération",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le trait d’union garde lui-même une fonction. Il ne se contente pas d’accoler deux mots. Il indique un passage, une couture, une articulation, une zone de contact. Il signale que le multiple et le pluriel entrent dans une composition, qu’ils travaillent ensemble, qu’ils se corrigent mutuellement. Grâce à lui, le multiple échappe à la masse indistincte ; grâce à lui encore, le pluriel échappe à la simple énumération."
            },
            {
              "style": "Body Custom",
              "text": "Dans une lecture posœnnoïale, ce trait d’union pourrait presque se lire comme une micro-fonction d’Addition synchrêtique : un lieu de tressage entre deux charges sémantiques, un seuil d’articulation où chaque terme vient augmenter l’autre. Le Multiple-pluriel nomme donc déjà une opération, une façon de faire tenir ensemble la densité du champ et l’irréductibilité des présences."
            }
          ]
        },
        {
          "title_fr": "3. Une formulation de travail",
          "paras": [
            {
              "style": "Body Custom",
              "text": "À ce stade de l’anamnèse, une première formulation devient possible. Le Multiple-pluriel désigne la dynamique par laquelle une multiplicité de strates, de formes, de temps, de signes, de mémoires et d’apports accueille une pluralité de singularités, de présences et de voix, dans une cohérence vibratoire gardant les écarts actifs au lieu de les aplanir."
            },
            {
              "style": "Body Custom",
              "text": "Cette formulation demande ensuite à être éprouvée par le corpus et par les œuvres. Un concept trouve sa justesse lorsque le langage, la structure et la matière plastique convergent vers lui. Il la trouve aussi lorsque l’expérience du regard confirme sa nécessité, selon des degrés d’accès variables d’un sujet à l’autre. Car l’œuvre du Multiple-pluriel ne simplifie rien pour plaire à tous ; elle offre une chambre de résonance où chacun entre selon sa mesure de disponibilité, de culture et de traversée intérieure."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "VI. Le Multiple-pluriel dans l’architecture du Posœnnoïsme",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. RéZonans : le liage vibratoire du champ",
          "paras": [
            {
              "style": "Body Custom",
              "text": "RéZonans constitue l’un des grands opérateurs du Multiple-pluriel. Son geste relie l’individu à l’environnement, à l’histoire, aux histoires, à la conscience, à la subconscience, à l’inconscience, au souffle, à l’esprit et à l’âme dans un mouvement perpétuel de transformation et d’harmonie. Une telle description indique déjà que le réel, chez vous, se présente comme tissu d’interactions, comme champ d’échos et de réaccordages. Le Multiple-pluriel reçoit ici son principe de liage."
            },
            {
              "style": "Body Custom",
              "text": "Grâce à RéZonans, la multiplicité des éléments, des influences et des intensités acquiert un régime de relation. La pluralité des singularités trouve, quant à elle, un plan d’interaction vivant. RéZonans permet donc au Multiple-pluriel de devenir habitable. Il transforme la coexistence en accordage, l’écart en tension féconde, la distance en possibilité d’écoute."
            }
          ]
        },
        {
          "title_fr": "2. Illusion : la perception du Multiple-pluriel",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Illusion tient une place majeure dans l’économie du concept. Le corpus la présente comme fluctuation active entre perception et réalité, comme interface mouvante ouvrant l’exploration de nouvelles dimensions du sens et des prismes subjectifs. Une formulation va jusqu’à préciser : « C’est voir et regarder le Multiple-pluriel. » Cette phrase offre une clef directe."
            },
            {
              "style": "Body Custom",
              "text": "Le Multiple-pluriel possède en effet une condition perceptive. Il faut pouvoir percevoir plusieurs niveaux d’apparition, sentir plusieurs foyers en interaction, accueillir l’instabilité des évidences, consentir à des configurations où l’image, la mémoire, l’affect et le sens circulent entre plusieurs états. Illusion permet cette lecture. Elle opère comme organe de complexification perceptive. Elle rappelle aussi que la réception ne se distribue jamais uniformément : l’œuvre contient plus que ce qu’un regard immédiatement disponible peut en extraire. Le seuil de lecture dépend d’une liberté d’esprit, d’un capital culturel, d’une expérience de vie et d’une qualité de présence face à l’œuvre."
            }
          ]
        },
        {
          "title_fr": "3. Aliœvolution : le rôle de l’altérité",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Aliœvolution apporte au Multiple-pluriel une dimension fondamentale : l’altérité comme moteur de transformation. Une esthétique du Multiple-pluriel appelle toujours une relation à l’autre, au différent, au décentrant, au contextuel, au culturel, à l’historique, au symbolique. Dans le champ posœnnoïal, l’altérité prend la forme d’un moteur interne de métamorphose, jamais d’un supplément ornemental. Elle travaille la trajectoire même de la forme et du sujet. Elle nourrit l’enracinement, la transformation progressive et la continuité vivante."
            },
            {
              "style": "Body Custom",
              "text": "Le Multiple-pluriel gagne ainsi une dimension relationnelle et terrestre. Il se développe par ramification, par dialogue, par coévolution, par accueil du dehors dans une structure qui conserve son axe. Là encore, la notion s’épaissit : la pluralité des présences devient dynamique de croissance, la multiplicité des apports devient matière d’évolution tenue."
            }
          ]
        },
        {
          "title_fr": "4. Péroptissimisme : la tension constructive",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Péroptissimisme ajoute la dimension de tension constructive, de frottement actif entre lucidité, réalisme, pessimisme, optimisme et espérance. Une esthétique du Multiple-pluriel appelle une telle tension, car plusieurs régimes de présence, plusieurs mémoires et plusieurs plans de réalité se rencontrent rarement sur le mode d’une paix lisse. Ils se frottent, se heurtent, se corrigent, s’éprouvent."
            },
            {
              "style": "Body Custom",
              "text": "La peinture ici considérée témoigne constamment de cette dramaturgie. Les formes y avancent à travers l’accident, la fracture, la reprise, la densification, l’effacement et la relance. Le Multiple-pluriel reçoit donc, par Péroptissimisme, sa part de conflictualité féconde. La pluralité reste vive, la multiplicité reste mobile, l’ensemble garde une respiration dramatique."
            }
          ]
        },
        {
          "title_fr": "5. L’Addition synchrêtique : l’organe de composition",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Parmi les outils, l’Addition synchrêtique occupe une place cardinale. Elle dépasse la juxtaposition, elle module chaque apport et le met en vibration avec l’ensemble vivant, générant une structure signifiante nouvelle. Voilà précisément le type d’opération qu’exige l’esthétique du Multiple-pluriel. Le multiple y apporte les matériaux. Le pluriel y garantit les singularités. L’Addition synchrêtique en organise la cohabitation active."
            },
            {
              "style": "Body Custom",
              "text": "Grâce à elle, le Multiple-pluriel prend la forme d’une composition. Une composition, dans le système posœnnoïal, conserve les différences, travaille les compatibilités, transforme les marges en charnières et les restes en matrices. Une telle logique distingue fortement cette pensée d’une fusion indifférenciée. L’Addition synchrêtique produit du liage, de l’accordage, du passage, de la forme opérative."
            }
          ]
        },
        {
          "title_fr": "6. Superposition de perspectives : la polyfocalité",
          "paras": [
            {
              "style": "Body Custom",
              "text": "La Superposition de perspectives permet de tenir ensemble plusieurs angles, plusieurs niveaux, plusieurs focales. Elle donne au Multiple-pluriel sa polyfocalité. Une œuvre ainsi conçue appelle plusieurs regards, plusieurs entrées, plusieurs régimes de lecture. Le réel cesse d’y apparaître sous un angle unique ; il devient champ feuilleté, espace d’obliquités, constellation de points de saisie."
            },
            {
              "style": "Body Custom",
              "text": "Ce principe agit visiblement dans les œuvres. Le regard glisse d’un foyer à l’autre, d’un contour à une masse, d’une figure potentielle à un fond devenu actif, d’une mémoire du visage à une abstraction en devenir, d’un corps à une architecture. La perspective s’y pluralise, le sensible s’y démultiplie."
            }
          ]
        },
        {
          "title_fr": "7. Instantané multiple : la polytemporalité",
          "paras": [
            {
              "style": "Body Custom",
              "text": "L’Instantané multiple donne au concept son épaisseur temporelle. Un instant, dans la pensée posœnnoïale, peut contenir plusieurs temps, plusieurs strates de vécu, plusieurs niveaux de perception, plusieurs mémoires en activité. Le Multiple-pluriel y gagne une puissance essentielle : il se montre comme coexistence de temporalités."
            },
            {
              "style": "Body Custom",
              "text": "Les toiles témoignent de cette polytemporalité. Une forme semble parfois porter son esquisse, son effacement, sa reprise, sa blessure, sa future dissipation et sa condensation finale dans le même champ visuel. Le tableau donne à voir du temps stratifié, du temps froissé, du temps traversant la matière en plusieurs sens. Le Multiple-pluriel devient alors aussi une forme de temps."
            }
          ]
        },
        {
          "title_fr": "8. Sujet pluriel : l’architecture intérieure du concept",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le Sujet pluriel constitue peut-être la chambre la plus intérieure du Multiple-pluriel. Il est ce lieu où les apports, encore imprégnés de leurs trajectoires premières, trouvent un espace pour se déposer, frémir et s’accorder. Cette définition confère au concept sa dimension anthropologique la plus forte. Le Multiple-pluriel ne caractérise pas seulement l’œuvre ou le monde ; il caractérise aussi l’être capable de les porter."
            },
            {
              "style": "Body Custom",
              "text": "Le sujet, dans la pensée posœnnoïale, relève d’une forme intérieure en recomposition continue. Il garde plusieurs couches, plusieurs voix, plusieurs mémoires, plusieurs projections et plusieurs intensités. Il offre donc au Multiple-pluriel son habitation subjective. L’esthétique du Multiple-pluriel devient ainsi indissociable d’une anthropologie du sujet complexe, traversé, stratifié et transformable."
            }
          ]
        },
        {
          "title_fr": "9. Les Modalités opératives : la vie du Multiple-pluriel",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Les Modalités opératives apportent enfin au concept sa mobilité fine. La Temporalité éclatée, la Temporalité élargie, la Stratification d’expériences, l’Expérience fragmentée, la Conscience vibratoire, les diverses lucidité, l’Adaptabilité critique et ouverte, l’Identité évolutive ou encore l’Exploration de l’inconnu rendent possible la vie du Multiple-pluriel. Grâce à elles, la notion échappe à tout figement théorique. Elle devient pratique de lecture, pratique de création, pratique d’existence."
            },
            {
              "style": "Body Custom",
              "text": "Le Multiple-pluriel reçoit donc du Posœnnoïsme une structure complète. RéZonans en règle les rapports, Illusion en aiguise la perception, Aliœvolution en nourrit le devenir, Péroptissimisme en dramatise la tension, l’Addition synchrêtique en compose les matériaux, la Superposition de perspectives en ouvre les angles, l’Instantané multiple en déploie les temps, le Sujet pluriel en offre l’habitation, les Modalités opératives en assurent les usages, les variations et les passages."
            },
            {
              "style": "Normal",
              "text": "✦"
            }
          ]
        }
      ]
    },
    {
      "title_fr": "VII. Manifestations plastiques : ce que les œuvres donnent déjà à voir",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. Une esthétique de la zone de contact",
          "paras": [
            {
              "style": "Body Custom",
              "text": "L’une des premières caractéristiques plastiques de cette œuvre réside dans l’importance de la zone de contact. Cette expression, présente très tôt dans la formulation inaugurale, possède une valeur décisive. La forme, ici, vit dans la relation entre son contour et « l’autour » qui la constitue. Le tableau travaille donc un espace de bordure active, un lieu où le fond entre dans la forme, où la forme rejaillit dans le fond, où un dehors devient intérieur de l’apparition."
            },
            {
              "style": "Body Custom",
              "text": "Une telle zone de contact constitue déjà une expression du Multiple-pluriel. Plusieurs régimes s’y croisent : figure et champ, trace et masse, présence et retrait, geste rapide et construction lente, ligne incisive et brouillard lumineux, matière dense et respiration vide. Le tableau tient alors moins de l’image fermée que du milieu générateur. Il porte un monde en train de se faire à travers ses frictions."
            }
          ]
        },
        {
          "title_fr": "2. « Renaissance » : apparition, fracture, remontée du sensible",
          "images": [
            {
              "title": "Renaissance",
              "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Renaissance_1.jpg?v=1730071434"
            }
          ],
          "paras": [
            {
              "style": "Body Custom",
              "text": "Dans la grande toile en noir, blanc et gris, la logique du Multiple-pluriel se manifeste avec une vigueur particulière. La palette réduite concentre l’attention sur la structure du champ. Les masses circulaires, les arcs, les verticales minces, les griffures obliques, les surgissements de blanc et les coulures sombres organisent une scène où plusieurs niveaux d’apparition se chevauchent. Une figure humaine semble affleurer, puis se dédoubler, puis se perdre dans l’architecture même du tableau. Le regard reçoit plusieurs foyers simultanés, plusieurs commencements de corps, plusieurs rappels de masque, plusieurs fractures du plan."
            },
            {
              "style": "Body Custom",
              "text": "Ici, le Multiple relève du feuilletage et du heurt. Le Pluriel relève des présences qui cherchent leur place dans un même champ, sans convergence totale vers une seule figure stable. L’œuvre produit un espace d’apparition discontinue, un théâtre du seuil, où la forme avance par rémanence, collision et relance. Elle donne au Multiple-pluriel une expression grave, dense, presque liminale."
            }
          ]
        },
        {
          "title_fr": "3. Les « Corps et décors » : identité en voie d’émergence",
          "images": [
            {
              "title": "Corps et décors 1",
              "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Appearances1_acryliconcanvas_40x40cm_2200_Goody_ADAGPParis2024_64662f9a-7a9b-4f7c-b305-6f6ac0418a36.jpg?v=1730044152"
            },
            {
              "title": "Corps et décors 4",
              "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Appearances4_acryliconcanvas_40x40cm_2200_Goody_ADAGPParis2024_6cb82a23-38b8-48b4-82d5-54295f6cdec3.jpg?v=1730062853"
            }
          ],
          "paras": [
            {
              "style": "Body Custom",
              "text": "Les deux œuvres intitulées Corps et décors intensifient une autre dimension du concept : la pluralité des états d’apparition. Les formes y portent quelque chose du masque, du visage, du torse, du végétal, de l’organe, du drapé et de la flamme colorée. Elles vivent dans une zone intermédiaire où l’identité visuelle reste ouverte. Une figure y surgit, aussitôt travaillée par d’autres devenirs possibles."
            },
            {
              "style": "Body Custom",
              "text": "Le Multiple s’y lit dans les plans chromatiques superposés, les masses pliées, les courbes qui se coupent, les membranes colorées qui se poussent mutuellement. Le Pluriel, lui, se lit dans les identités possibles que l’œuvre maintient ensemble : humain, masque, apparition, fragment, passage. Aucune lecture unique n’épuise ces tableaux. Chacun agit comme foyer de pluralisation du regard."
            }
          ]
        },
        {
          "title_fr": "4. « Méfyans » : la syntaxe de l’entrelacs",
          "images": [
            {
              "title": "Méfyans (Insomnie 2)",
              "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Mefyans_-_-Insomnie-2.jpg?v=1732142021"
            }
          ],
          "paras": [
            {
              "style": "Body Custom",
              "text": "Méfyans porte peut-être l’une des formes les plus manifestes du Multiple-pluriel comme entrelacs. La toile tresse des rubans, des organes, des membranes, des segments, des courbes enveloppantes, des masses colorées et des coupes blanches qui ouvrent des respirations. Plusieurs corps semblent y cohabiter dans le même corps, plusieurs faces de l’espace s’y retournent, plusieurs profondeurs s’y nouent."
            },
            {
              "style": "Body Custom",
              "text": "La logique de plissement issue de multiplex trouve ici une traduction saisissante. Le tableau se comporte comme tissu en torsion, comme organisme à plusieurs couches, comme nœud de passages. Quant au pluriel, il s’exprime par la coprésence de plusieurs centres d’énonciation formelle. L’œil circule d’un noyau à l’autre, d’une courbe à une poche d’ombre, d’une ouverture blanche à une poussée chromatique. La toile se lit comme monde en migration interne."
            }
          ]
        },
        {
          "title_fr": "5. « Synchét’Isme » : condensation et orchestration",
          "images": [
            {
              "title": "Synchrét’Ismes",
              "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Synchet_Isme_extrait_0.jpg?v=1728292583"
            }
          ],
          "paras": [
            {
              "style": "Body Custom",
              "text": "Synchét’Isme donne au Multiple-pluriel un régime plus condensé, plus axial, plus orchestré. Une grande forme ovoïde ou circulatoire enserre et relance la structure interne. Le champ bleu, blanc et gris installe une tension entre apaisement, coupe nette, surgissement et profondeur. Le tableau offre un exemple remarquable de multiplicité organisée par condensation."
            },
            {
              "style": "Body Custom",
              "text": "Ici, le multiple des plans et des foyers trouve une tenue plus resserrée. Le pluriel des présences demeure actif, mais leur cohabitation passe par une orchestration plus visible. La peinture montre ainsi qu’une esthétique du Multiple-pluriel peut accueillir plusieurs degrés de turbulence : parfois l’explosion feuilletée, parfois la condensation circulatoire, parfois le quasi-portrait, parfois l’organisme abstrait, parfois le champ d’apparitions latentes."
            }
          ]
        },
        {
          "title_fr": "6. « Upheaval » : le foyer de bascule",
          "images": [
            {
              "title": "Upheaval",
              "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Upheaval_extrait1.jpg?v=1728338920"
            }
          ],
          "paras": [
            {
              "style": "Body Custom",
              "text": "Upheaval, même sous forme d’extrait, montre une autre dimension encore : le foyer de bascule. Une masse centrale sombre et rougeoyante agit comme noyau d’intensité, tandis qu’un champ plus clair et atmosphérique étend autour d’elle plusieurs poussées, traces et percées lumineuses. Le Multiple-pluriel prend ici la forme d’une scène énergétique où plusieurs états de la matière picturale coexistent : condensation, expansion, effraction, halos, suintements, percées."
            },
            {
              "style": "Body Custom",
              "text": "Le tableau donne à sentir que la pluralité peut résider dans les régimes mêmes de la matière et du geste. Plusieurs manières d’exister picturalement cohabitent. La forme y devient événement, et l’événement garde plusieurs modes de présence à la fois."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "VIII. Ce que l’esthétique du Multiple-pluriel distingue et dépasse",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. Davantage qu’une diversité",
          "paras": [
            {
              "style": "Body Custom",
              "text": "La diversité désigne fréquemment la variété des éléments présents. Elle constate. Elle classe. Elle accueille. L’esthétique du Multiple-pluriel, elle, compose. Elle organise des rapports, densifie des écarts, module des intensités, travaille les conditions d’une unité hétérogène. Une œuvre diverse peut juxtaposer plusieurs éléments. Une œuvre du Multiple-pluriel transforme leur coexistence en champ de nécessité."
            }
          ]
        },
        {
          "title_fr": "2. Davantage qu’un éclectisme",
          "paras": [
            {
              "style": "Body Custom",
              "text": "L’éclectisme choisit dans plusieurs sources. Il prélève, combine, agence. L’œuvre ici considérée accomplit un geste plus profond. L’Addition synchrêtique, moteur essentiel de la pensée posœnnoïale, soumet les apports à une mise en vibration, à une épreuve de compatibilité active et à une transformation interne. Ainsi, une source culturelle, philosophique, symbolique ou plastique entre dans un processus d’accordage. Elle change de statut. Elle cesse d’être citation ; elle devient matériau de recomposition."
            }
          ]
        },
        {
          "title_fr": "3. Davantage qu’un syncrétisme fusionnel",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le terme syncrétisme, pris dans son sens courant, évoque souvent la fusion de traditions différentes. Or le champ posœnnoïal distingue explicitement l’Addition synchrêtique d’une coagulation confuse. Le Multiple-pluriel partage avec certaines pensées syncrétiques le souci du croisement, tout en gardant une autre exigence : préserver la singularité vibratoire des apports, ménager l’écart, faire tenir ensemble sans lisser. Il relève donc d’un art du tressage plutôt que d’une fusion compacte."
            }
          ]
        },
        {
          "title_fr": "4. Davantage qu’une fragmentation postmoderne",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le fragmentaire postmoderne a souvent valorisé la dispersion, la rupture, l’ironie, l’éclatement des récits et la déconstruction des centres. La pensée posœnnoïale rencontre bien une partie de cette histoire, surtout lorsqu’elle accueille l’Expérience fragmentée, la Temporalité éclatée ou le trouble des évidences. Pourtant l’orientation reste autre. Le fragment, ici, appelle le passage, la recomposition, le seuil actif et la relance vibratoire. Le Multiple-pluriel garde donc le tranchant du fragment tout en orientant la forme vers une cohérence respirante."
            }
          ]
        },
        {
          "title_fr": "5. Davantage qu’une multiplicité optique",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Certaines expériences historiques, du cubisme à diverses abstractions analytiques, ont déjà porté plusieurs points de vue dans un même plan. Une proximité existe. L’esthétique ici formulée élargit cependant considérablement le champ. Le Multiple-pluriel relève de plusieurs niveaux à la fois : optique, temporel, mémoriel, symbolique, affectif, culturel, ontologique et vibratoire. La pluralité des points de vue s’y étend à une pluralité des régimes d’être."
            }
          ]
        },
        {
          "title_fr": "6. En résonance avec le Tout-Monde et le spiralisme, dans une orientation propre",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le corpus d’Anamnésis rapproche cette pensée du Tout-Monde de Glissant et du spiralisme. Ces rapprochements éclairent un voisinage réel. Le Tout-Monde pense la relation des différences en expansion, la créolisation et l’opacité. Le spiralisme accueille la turbulence, les beautés fêlées, le chaos organisateur. L’esthétique du Multiple-pluriel résonne fortement avec ces héritages. Elle leur ajoute toutefois une architecture opérative spécifique : Outils, Piliers, Engrenages, Modalités et matrice donnent à la complexité un système de circulation, d’activation et de régulation. Ainsi, ce concept appartient à une famille de pensées du relationnel, du fragmentaire et du polyphonique, tout en portant une singularité structurelle forte."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "IX. La portée de l’esthétique du Multiple-pluriel",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. Portée plastique",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Sur le plan plastique, l’esthétique du Multiple-pluriel ouvre une compréhension fine du travail de composition. Elle éclaire le rôle des chevauchements, de la figure inachevée, des zones de contact, des tensions entre fond et forme, des glissements d’identité, des structures feuilletées, des foyers polycentriques, des temporalités inscrites dans la matière et des reprises internes du geste. Elle permet de lire les tableaux comme des organismes complexes, à la fois unifiés et traversés."
            }
          ]
        },
        {
          "title_fr": "2. Portée perceptive",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Sur le plan perceptif, elle transforme la réception. Le regardeur ne cherche plus un seul motif à reconnaître, une seule clef iconique, un seul sujet souverain. Il apprend à circuler, à écouter, à demeurer dans l’épaisseur de l’apparaître. Cette réception dépend fortement de la liberté d’esprit, du capital culturel, de l’expérience de vie et de la posture adoptée face à l’œuvre. Une œuvre du Multiple-pluriel n’entre donc jamais dans le régime d’un « chacun voit ce qu’il veut » ; elle relève d’un « chacun voit ce qu’il peut », selon l’étendue de sa disponibilité intérieure, la souplesse de sa pensée, la mémoire des formes qu’il porte en lui et la qualité du temps qu’il accorde à l’œuvre. Le regard devient alors plus ample, plus mobile, plus stratifié ; il reçoit peu à peu qu’une œuvre tient en elle une résonance du tout, dont chaque lecture n’épuise qu’une part."
            }
          ]
        },
        {
          "title_fr": "3. Portée anthropologique",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Sur le plan anthropologique, le concept offre une réponse forte aux identités contemporaines travaillées par la pluralité, la mémoire, la migration, les héritages croisés, la conflictualité des appartenances et la tension entre singularité et collectif. Le Sujet pluriel donne ici un modèle profond : être revient à habiter plusieurs couches, plusieurs temps, plusieurs voix et plusieurs devenirs tout en conservant une tenue intérieure. Cette esthétique ouvre ainsi une anthropologie du sujet complexe et respirant."
            }
          ]
        },
        {
          "title_fr": "4. Portée épistémologique",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Sur le plan de la connaissance, le Multiple-pluriel propose une méthode de pensée. Il autorise le croisement des disciplines, des traditions, des cosmologies, des récits, des symboliques et des expériences, tout en demandant une organisation rigoureuse des passages. Il donne au savoir une forme polyphonique, stratifiée, non soustractive, fidèle à l’esprit même de la Posœnnoïa."
            }
          ]
        },
        {
          "title_fr": "5. Portée philosophique",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Sur le plan philosophique, le concept déplace la question de l’unité. L’unité cesse d’être une clôture homogène. Elle devient tension relationnelle, cohérence respirante, accord dynamique. Une pensée du Multiple-pluriel propose ainsi une ontologie de l’unité hétérogène : le réel apparaît comme champ de présences différenciées en interaction, et l’être se donne comme composition vibratoire de singularités."
            }
          ]
        },
        {
          "title_fr": "6. Portée politique et éthique",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Sur le plan politique et éthique, l’esthétique du Multiple-pluriel ouvre une manière de penser le commun à partir des différences vivantes. Elle appelle un espace où plusieurs voix, plusieurs histoires, plusieurs cultures et plusieurs sensibilités trouvent une composition active au lieu d’un effacement réciproque. Elle valorise une relation tenue, une altérité féconde, une coexistence exigeante. À cet endroit, cette esthétique rejoint la nécessité contemporaine d’un monde capable d’unité sans réduction."
            }
          ]
        },
        {
          "title_fr": "7. Portée spirituelle et vibratoire",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Enfin, sur le plan vibratoire, le Multiple-pluriel permet de penser les relations entre visible et invisible, mémoire et à-venir, intériorité et extériorité, matière et champ, présence sensible et profondeur cosmique. Dans le Posœnnoïsme, toute chose entre en rapport avec d’autres couches du réel. Le Multiple-pluriel devient alors la forme sensible de cette continuité. Il donne à sentir un monde plus vaste que sa seule apparence immédiate."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "X. Proposition de définition du concept",
      "intro": [],
      "subsections": [
        {
          "title_fr": "1. Formulation développée",
          "paras": [
            {
              "style": "Body Custom",
              "text": "L’esthétique du Multiple-pluriel désigne un régime de création, de perception et de pensée dans lequel l’œuvre organise la coexistence active de plusieurs strates, plusieurs temps, plusieurs mémoires, plusieurs formes, plusieurs voix, plusieurs régimes de présence et plusieurs héritages, au sein d’une cohérence vibratoire assez forte pour faire tenir l’ensemble, assez ouverte pour préserver la singularité de chaque foyer, de sorte que l’unité y advienne comme tension relationnelle, modulation et passage plutôt que comme homogénéisation."
            }
          ]
        },
        {
          "title_fr": "2. Formulation posœnnoïale resserrée",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Le Multiple-pluriel est la dynamique par laquelle une multiplicité de plis, de fragments, de temporalités, de signes et d’apports accueille une pluralité de singularités, de présences et de voix, dans une unité hétérogène régulée par RéZonans, composée par Addition synchrêtique, ouverte par Superposition de perspectives, densifiée par Instantané multiple, habitée par le Sujet pluriel et transmise par l’Organon posœnnoïal comme forme vivante de relation, de transmutation et d’apparition."
            }
          ]
        },
        {
          "title_fr": "3. Formule brève à destination du lexique",
          "paras": [
            {
              "style": "Body Custom",
              "text": "Esthétique du Multiple-pluriel : régime sensible, poïétique et vibratoire où plusieurs strates et plusieurs singularités coexistent, se modulent et se relancent dans une unité hétérogène gardant les écarts actifs."
            }
          ]
        }
      ]
    },
    {
      "title_fr": "XI. Inscription dans le lexique et le champ posœnnoïal",
      "intro": [
        {
          "style": "Body Custom",
          "text": "Le concept gagne aujourd’hui une légitimité claire au sein du Posœnnoïsme. Plusieurs options deviennent envisageables pour sa stabilisation. Il peut apparaître comme notion transversale explicitement rattachée à Axis, tant il irrigue les quatre Outils et le jeu des Piliers. Il peut aussi recevoir une fiche conceptuelle autonome, en dialogue avec RéZonans, l’Addition synchrêtique et le Sujet pluriel. Il peut enfin fonctionner comme entrée critique dans les textes de présentation générale, les dossiers artistiques, les analyses d’œuvres et les formulations destinées à la diffusion du Posœnnoïsme, puisqu’il nomme avec une grande précision ce que la peinture et le système accomplissent déjà."
        },
        {
          "style": "Body Custom",
          "text": "Sa place paraît d’autant plus justifiée qu’il relie directement la pratique plastique, le vécu perceptif, la formulation conceptuelle et la dimension philosophique du système. Peu de notions possèdent une telle transversalité. Le Multiple-pluriel touche à la composition, à la lecture, à l’être, à la relation, à la mémoire, à l’altérité, à la temporalité et à la vibration. Il agit comme un nœud de cohérence entre plusieurs régions du champ posœnnoïal."
        },
        {
          "style": "Body Custom",
          "text": "Sa présence appelle aussi une attention particulière du côté du lexique trilingue. À ce stade, la formulation française « Multiple-pluriel » garde valeur de formulation-source, car elle tient une tension interne délicate entre densité stratifiée et pluralité des présences. Toute transposition vers l’anglais ou l’espagnol demande donc une grande vigilance, afin de préserver la charge conceptuelle du syntagme, la tenue du trait d’union et la logique relationnelle qu’il abrite. L’inscription trilingue gagnera à s’effectuer dans le respect des règles déjà établies par le lexique opératif du corpus, sans altération des termes canoniques et sans affaiblissement de leur charge sémantique."
        }
      ],
      "subsections": []
    },
    {
      "title_fr": "Conclusion",
      "intro": [
        {
          "style": "Body Custom",
          "text": "L’esthétique du Multiple-pluriel apparaît, au terme de cette traversée, comme l’une des formulations les plus justes pour nommer la loi profonde du parcours artistique de Goodÿ et l’une des articulations les plus fécondes du Posœnnoïsme. Elle trouve son ancrage dans l’aísthêsis, dans la profondeur plissée de multiplex, dans la présence pleine et entière de pluralis. Elle se vérifie dans la matière des tableaux, dans la collection d’Ordo Ab Chaos, dans la logique d’Axis, dans le jeu des Outils, dans le régime du Sujet pluriel et dans les Modalités opératives qui rendent la complexité habitable."
        },
        {
          "style": "Body Custom",
          "text": "Elle nomme une unité hétérogène, une forme respirante, une cohabitation de strates et de singularités, un art de faire tenir l’écart, un principe d’apparition du réel lorsque plusieurs mondes, plusieurs temps, plusieurs mémoires et plusieurs devenirs entrent dans la même dynamique de vie, dans le respect des différences. Elle donne à la peinture une profondeur théorique rendue sensible par la matière, une ossature de pensée enveloppée de chair plastique, tenue par un fascia invisible de liens, de tensions et de passages. Dans cette esthétique, les œuvres expriment la plasticité de l’invisible et du sens, donnant au sujet une architecture et au monde une manière d’être reçu."
        },
        {
          "style": "Body Custom",
          "text": "On pourrait dire que l’esthétique du Multiple-pluriel, qui est à la fois immanence de l’œuvre et relation dans sa réception, cherche à rendre sensible la manière dont toute forme gagne en justesse dès lors qu’elle laisse parler plusieurs présences, plusieurs temps, plusieurs couches et plusieurs intensités dans un même espace. Cette justesse, toutefois, advient pleinement au contact d’un regard capable d’habiter l’œuvre plutôt que de la consommer, d’un regard assez libre pour soutenir l’ambiguïté, assez nourri pour reconnaître certaines strates, assez vivant pour laisser l’œuvre élargir sa propre mesure."
        },
        {
          "style": "Body Custom",
          "text": "Cette esthétique sera déployée et adaptée à différents usages : fiche conceptuelle, entrée de lexique, texte de présentation générale, analyse d’œuvre, page de référence au sein du champ posœnnoïal. Pour l’heure, ce document lui offre une demeure ample, dense et fondatrice. Il ouvre une porte aux écritures futures qui en déplieront d’autres aspects."
        }
      ],
      "subsections": [
        {
          "title_fr": "Repère terminologique final",
          "paras": [
            {
              "style": "Small Custom",
              "text": "Le terme « Multiple-pluriel » désigne ici une formulation conceptuelle en voie de stabilisation au sein du champ posœnnoïal. Les termes canoniques déjà établis dans le lexique trilingue conservent leur graphie, leur capitalisation et leur régime d’usage propres. Toute articulation ultérieure du Multiple-pluriel avec le lexique opératif gagnera à respecter cette écologie interne du corpus."
            }
          ]
        }
      ]
    }
  ],
  "gallery_section": {
    "title_fr": "Œuvres mises en regard",
    "intro": [
      {
        "style": "Body Custom",
        "text": "Avant de poursuivre vers l’analyse plastique détaillée, cet ensemble rassemble quelques foyers visuels dont la lecture a nourri la présente réflexion."
      },
      {
        "style": "Caption Custom",
        "text": "Corps et décors 1, Corps et décors 4, « Renaissance », Upheaval."
      },
      {
        "style": "Caption Custom",
        "text": "Méfyans et Synchét’Isme."
      }
    ],
    "subsections": []
  },
  "historical_intro": {
    "title_fr": "Introduction — Une présence depuis 2001",
    "paras": [
      {
        "style": "Body Custom",
        "text": "Le Multiple-pluriel n’apparaît pas ici comme une formulation tardive. Dès 2001, il existe dans le parcours de Goodÿ comme titre, comme orientation plastique et comme seuil de pensée autour de l’identité, du métissage biologique et culturel, de la pluralité des émotions et des manières d’exprimer une même réalité. Cette antériorité importe : elle montre que le concept actuel ne vient pas recouvrir l’œuvre après coup, mais donne une forme plus précise à une intuition déjà engagée dans la peinture."
      },
      {
        "style": "Body Custom",
        "text": "Depuis cette première apparition publique, le Multiple-pluriel accompagne la recherche d’une unité qui se construit par les différences, plutôt que par leur effacement. Il nomme peu à peu une manière de faire tenir ensemble les signes, les mémoires, les corps, les lieux, les tensions et les présences dans un même champ sensible. Le Posœnnoïsme permet aujourd’hui d’en stabiliser la portée, sans en réduire l’origine picturale."
      }
    ]
  },
  "gallery": [
    {
      "title": "Renaissance",
      "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Renaissance_1.jpg?v=1730071434"
    },
    {
      "title": "Méfyans (Insomnie 2)",
      "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Mefyans_-_-Insomnie-2.jpg?v=1732142021"
    },
    {
      "title": "Synchrét’Ismes",
      "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Synchet_Isme_extrait_0.jpg?v=1728292583"
    },
    {
      "title": "Corps et décors 1",
      "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Appearances1_acryliconcanvas_40x40cm_2200_Goody_ADAGPParis2024_64662f9a-7a9b-4f7c-b305-6f6ac0418a36.jpg?v=1730044152"
    },
    {
      "title": "Corps et décors 4",
      "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Appearances4_acryliconcanvas_40x40cm_2200_Goody_ADAGPParis2024_6cb82a23-38b8-48b4-82d5-54295f6cdec3.jpg?v=1730062853"
    },
    {
      "title": "Upheaval",
      "img": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Upheaval_extrait1.jpg?v=1728338920"
    }
  ],
  "ui": {
    "fr": {
      "title": "L’esthétique du Multiple-pluriel",
      "subtitle": "Anamnèse conceptuelle, lecture posœnnoïale et définition générale",
      "doclabel": "Document de présentation générale",
      "author": "Goodÿ – Gilles EUGENE",
      "rights": "Tous concepts, textes et œuvres du Posœnnoïsme : propriété intellectuelle de Goodÿ – Gilles EUGENE (© ADAGP Paris 2024).",
      "lang_note": "",
      "overview_title": "Aperçu",
      "def_short": "Régime sensible, poïétique et vibratoire où plusieurs strates et plusieurs singularités coexistent, se modulent et se relancent dans une unité hétérogène gardant les écarts actifs.",
      "summary_title": "Parcours du document",
      "summary_intro": "Accéder directement aux grands mouvements du texte.",
      "gallery_title": "Œuvres mises en regard",
      "gallery_intro": "Avant de poursuivre vers l’analyse plastique détaillée, cet ensemble rassemble quelques foyers visuels dont la lecture a nourri la présente réflexion.",
      "historical_intro_title": "Introduction — Une présence depuis 2001",
      "quote_title": "Citation-source",
      "chips": [
        {
          "label": "Superposition de perspectives",
          "href": "https://goodyart.store/pages/superposition-de-perspectives"
        },
        {
          "label": "Sujet pluriel",
          "href": "https://goodyart.store/pages/sujet-pluriel"
        },
        {
          "label": "Addition synchrêtique",
          "href": "https://goodyart.store/pages/addition-synchetique"
        },
        {
          "label": "Instantané multiple",
          "href": "https://goodyart.store/pages/instantane-multiple"
        }
      ],
      "cta_text": "Découvrir le Corpus",
      "audio_toggle": "Écouter le texte",
      "audio_pause": "Mettre en pause",
      "audio_resume": "Reprendre la lecture",
      "audio_stop": "Arrêter",
      "audio_listen_section": "Écouter la section",
      "audio_listen_block": "Écouter ce bloc",
      "audio_listen_intro": "Écouter l’introduction",
      "audio_listen_overview": "Écouter l’aperçu",
      "audio_listen_quote": "Écouter la citation-source",
      "audio_status_idle": "Lecture audio du document.",
      "audio_status_playing": "Lecture audio en cours.",
      "audio_status_paused": "Lecture audio en pause.",
      "audio_status_stopped": "Lecture audio arrêtée.",
      "body_notice": "",
      "gallery_caption_1": "Corps et décors 1, Corps et décors 4, « Renaissance », Upheaval.",
      "gallery_caption_2": "Méfyans (Insomnie 2) et Synchrét’Ismes.",
      "body_preserved_label": "Texte intégral"
    },
    "en": {
      "title": "L’esthétique du Multiple-pluriel",
      "subtitle": "Conceptual anamnesis, posœnnoïal reading and general definition",
      "doclabel": "General presentation document",
      "author": "Goodÿ – Gilles EUGENE",
      "rights": "Tous concepts, textes et œuvres du Posœnnoïsme : propriété intellectuelle de Goodÿ – Gilles EUGENE (© ADAGP Paris 2024).",
      "lang_note": "To preserve the exact French wording of the source document, the long-form body remains in French on this page. The navigation, interface elements, captions and structural headings switch to English while the canonical lexicon stays in French.",
      "overview_title": "Overview",
      "def_short": "A sensitive, poietic and vibratory regime in which multiple strata and multiple singularities coexist, modulate one another, and relaunch one another within a heterogeneous unity that keeps differences active.",
      "summary_title": "Document pathway",
      "summary_intro": "Jump directly to the major movements of the text.",
      "gallery_title": "Works in dialogue",
      "gallery_intro": "Before moving on to the detailed plastic analysis, this ensemble gathers several visual nuclei whose reading nourished the present reflection.",
      "historical_intro_title": "Introduction — A presence since 2001",
      "quote_title": "Source quotation",
      "chips": [
        {
          "label": "Superposition de perspectives",
          "href": "https://goodyart.store/pages/superposition-de-perspectives"
        },
        {
          "label": "Sujet pluriel",
          "href": "https://goodyart.store/pages/sujet-pluriel"
        },
        {
          "label": "Addition synchrêtique",
          "href": "https://goodyart.store/pages/addition-synchetique"
        },
        {
          "label": "Instantané multiple",
          "href": "https://goodyart.store/pages/instantane-multiple"
        }
      ],
      "cta_text": "Discover the Corpus",
      "audio_toggle": "Listen to the text",
      "audio_pause": "Pause",
      "audio_resume": "Resume playback",
      "audio_stop": "Stop",
      "audio_listen_section": "Listen to the section",
      "audio_listen_block": "Listen to this block",
      "audio_listen_intro": "Listen to the introduction",
      "audio_listen_overview": "Listen to the overview",
      "audio_listen_quote": "Listen to the source quotation",
      "audio_status_idle": "Audio playback of the document.",
      "audio_status_playing": "Audio playback in progress.",
      "audio_status_paused": "Audio playback paused.",
      "audio_status_stopped": "Audio playback stopped.",
      "body_notice": "French body preserved for exactitude.",
      "gallery_caption_1": "Corps et décors 1, Corps et décors 4, “Renaissance”, Upheaval.",
      "gallery_caption_2": "Méfyans (Insomnie 2) and Synchrét’Ismes.",
      "body_preserved_label": "Exact French body"
    },
    "es": {
      "title": "L’esthétique du Multiple-pluriel",
      "subtitle": "Anamnesis conceptual, lectura posœnnoïal y definición general",
      "doclabel": "Documento de presentación general",
      "author": "Goodÿ – Gilles EUGENE",
      "rights": "Tous concepts, textes et œuvres du Posœnnoïsme : propriété intellectuelle de Goodÿ – Gilles EUGENE (© ADAGP Paris 2024).",
      "lang_note": "Para preservar la redacción francesa exacta del documento fuente, el cuerpo largo permanece en francés en esta página. La navegación, los elementos de interfaz, los pies de imagen y los encabezados estructurales cambian al español, mientras el léxico canónico permanece en francés.",
      "overview_title": "Panorama",
      "def_short": "Régimen sensible, poiético y vibratorio en el que múltiples estratos y múltiples singularidades coexisten, se modulan y se relanzan dentro de una unidad heterogénea que mantiene activos los intervalos.",
      "summary_title": "Recorrido del documento",
      "summary_intro": "Acceder directamente a los grandes movimientos del texto.",
      "gallery_title": "Obras puestas en diálogo",
      "gallery_intro": "Antes de pasar al análisis plástico detallado, este conjunto reúne varios focos visuales cuya lectura alimentó la presente reflexión.",
      "historical_intro_title": "Introducción — Una presencia desde 2001",
      "quote_title": "Cita-fuente",
      "chips": [
        {
          "label": "Superposition de perspectives",
          "href": "https://goodyart.store/pages/superposition-de-perspectives"
        },
        {
          "label": "Sujet pluriel",
          "href": "https://goodyart.store/pages/sujet-pluriel"
        },
        {
          "label": "Addition synchrêtique",
          "href": "https://goodyart.store/pages/addition-synchetique"
        },
        {
          "label": "Instantané multiple",
          "href": "https://goodyart.store/pages/instantane-multiple"
        }
      ],
      "cta_text": "Descubrir el Corpus",
      "audio_toggle": "Escuchar el texto",
      "audio_pause": "Pausar",
      "audio_resume": "Reanudar la lectura",
      "audio_stop": "Detener",
      "audio_listen_section": "Escuchar la sección",
      "audio_listen_block": "Escuchar este bloque",
      "audio_listen_intro": "Escuchar la introducción",
      "audio_listen_overview": "Escuchar el panorama",
      "audio_listen_quote": "Escuchar la cita-fuente",
      "audio_status_idle": "Lectura en audio del documento.",
      "audio_status_playing": "Lectura en audio en curso.",
      "audio_status_paused": "Lectura en audio en pausa.",
      "audio_status_stopped": "Lectura en audio detenida.",
      "body_notice": "Cuerpo francés preservado para la exactitud.",
      "gallery_caption_1": "Corps et décors 1, Corps et décors 4, « Renaissance », Upheaval.",
      "gallery_caption_2": "Méfyans (Insomnie 2) y Synchrét’Ismes.",
      "body_preserved_label": "Cuerpo francés exacto"
    }
  },
  "title_maps": {
    "en": {
      "h1": {
        "Préambule méthodologique": "Methodological preamble",
        "I. Pourquoi le Multiple-pluriel appelle aujourd’hui une formulation explicite": "I. Why the Multiple-pluriel now calls for an explicit formulation",
        "II. Anamnèse du mot « esthétique »": "II. Anamnesis of the word “esthétique”",
        "III. Anamnèse du mot « multiple »": "III. Anamnesis of the word “multiple”",
        "IV. Anamnèse du mot « pluriel »": "IV. Anamnesis of the word “pluriel”",
        "V. Du voisinage des mots au concept : naissance du « Multiple-pluriel »": "V. From the neighborhood of words to the concept: birth of the “Multiple-pluriel”",
        "VI. Le Multiple-pluriel dans l’architecture du Posœnnoïsme": "VI. The Multiple-pluriel within the architecture of Posœnnoïsme",
        "Œuvres mises en regard": "Works in dialogue",
        "VII. Manifestations plastiques : ce que les œuvres donnent déjà à voir": "VII. Plastic manifestations: what the works already make visible",
        "VIII. Ce que l’esthétique du Multiple-pluriel distingue et dépasse": "VIII. What the esthétique of the Multiple-pluriel distinguishes and exceeds",
        "IX. La portée de l’esthétique du Multiple-pluriel": "IX. The reach of the esthétique of the Multiple-pluriel",
        "X. Proposition de définition du concept": "X. Proposed definition of the concept",
        "XI. Inscription dans le lexique et le champ posœnnoïal": "XI. Inscription within the lexicon and the posœnnoïal field",
        "Conclusion": "Conclusion"
      },
      "h2": {
        "1. Du sentir à la forme sensible": "1. From sensing to sensible form",
        "2. Le retour posœnnoïal à l’aísthêsis": "2. The posœnnoïal return to aísthêsis",
        "3. Première conséquence conceptuelle": "3. First conceptual consequence",
        "1. Le multiple comme plissement": "1. The multiple as folding",
        "2. Le multiple comme densité stratifiée": "2. The multiple as stratified density",
        "3. Le multiple comme réserve opérative": "3. The multiple as operative reserve",
        "1. De la grammaire à l’ontologie des présences": "1. From grammar to an ontology of presences",
        "2. Le pluriel comme irréductibilité des voix": "2. The plural as irreducibility of voices",
        "3. Le pluriel comme mode d’habitation": "3. The plural as a mode of inhabiting",
        "1. Pourquoi l’association des deux termes devient nécessaire": "1. Why the association of the two terms becomes necessary",
        "2. Le trait d’union comme opération": "2. The hyphen as operation",
        "3. Une formulation de travail": "3. A working formulation",
        "1. RéZonans : le liage vibratoire du champ": "1. RéZonans: the vibratory binding of the field",
        "2. Illusion : la perception du Multiple-pluriel": "2. Illusion: the perception of the Multiple-pluriel",
        "3. Aliœvolution : le rôle de l’altérité": "3. Aliœvolution: the role of alterity",
        "4. Péroptissimisme : la tension constructive": "4. Péroptissimisme: constructive tension",
        "5. L’Addition synchrêtique : l’organe de composition": "5. Addition synchrêtique: the organ of composition",
        "6. Superposition de perspectives : la polyfocalité": "6. Superposition de perspectives: polyfocality",
        "7. Instantané multiple : la polytemporalité": "7. Instantané multiple: polytemporality",
        "8. Sujet pluriel : l’architecture intérieure du concept": "8. Sujet pluriel: the inner architecture of the concept",
        "9. Les Modalités opératives : la vie du Multiple-pluriel": "9. Modalités opératives: the life of the Multiple-pluriel",
        "1. Une esthétique de la zone de contact": "1. An esthétique of the contact zone",
        "2. « Renaissance » : apparition, fracture, remontée du sensible": "2. “Renaissance”: apparition, fracture, and the upsurge of the sensible",
        "3. Les « Corps et décors » : identité en voie d’émergence": "3. “Corps et décors”: identity in the process of emergence",
        "4. « Méfyans » : la syntaxe de l’entrelacs": "4. “Méfyans”: the syntax of interlacing",
        "5. « Synchét’Isme » : condensation et orchestration": "5. “Synchét’Isme”: condensation and orchestration",
        "6. « Upheaval » : le foyer de bascule": "6. “Upheaval”: the pivoting focal point",
        "1. Davantage qu’une diversité": "1. More than diversity",
        "2. Davantage qu’un éclectisme": "2. More than eclecticism",
        "3. Davantage qu’un syncrétisme fusionnel": "3. More than fusionist syncretism",
        "4. Davantage qu’une fragmentation postmoderne": "4. More than postmodern fragmentation",
        "5. Davantage qu’une multiplicité optique": "5. More than optical multiplicity",
        "6. En résonance avec le Tout-Monde et le spiralisme, dans une orientation propre": "6. In resonance with the Tout-Monde and spiralism, yet in a distinct orientation",
        "1. Portée plastique": "1. Plastic reach",
        "2. Portée perceptive": "2. Perceptive reach",
        "3. Portée anthropologique": "3. Anthropological reach",
        "4. Portée épistémologique": "4. Epistemological reach",
        "5. Portée philosophique": "5. Philosophical reach",
        "6. Portée politique et éthique": "6. Political and ethical reach",
        "7. Portée spirituelle et vibratoire": "7. Spiritual and vibratory reach",
        "1. Formulation développée": "1. Expanded formulation",
        "2. Formulation posœnnoïale resserrée": "2. Condensed posœnnoïal formulation",
        "3. Formule brève à destination du lexique": "3. Brief formula for the lexicon",
        "Repère terminologique final": "Final terminological marker"
      }
    },
    "es": {
      "h1": {
        "Préambule méthodologique": "Preámbulo metodológico",
        "I. Pourquoi le Multiple-pluriel appelle aujourd’hui une formulation explicite": "I. Por qué el Multiple-pluriel llama hoy a una formulación explícita",
        "II. Anamnèse du mot « esthétique »": "II. Anamnesis de la palabra « esthétique »",
        "III. Anamnèse du mot « multiple »": "III. Anamnesis de la palabra « multiple »",
        "IV. Anamnèse du mot « pluriel »": "IV. Anamnesis de la palabra « pluriel »",
        "V. Du voisinage des mots au concept : naissance du « Multiple-pluriel »": "V. De la vecindad de las palabras al concepto: nacimiento del « Multiple-pluriel »",
        "VI. Le Multiple-pluriel dans l’architecture du Posœnnoïsme": "VI. El Multiple-pluriel en la arquitectura del Posœnnoïsme",
        "Œuvres mises en regard": "Obras puestas en diálogo",
        "VII. Manifestations plastiques : ce que les œuvres donnent déjà à voir": "VII. Manifestaciones plásticas: lo que las obras ya dejan ver",
        "VIII. Ce que l’esthétique du Multiple-pluriel distingue et dépasse": "VIII. Lo que la esthétique del Multiple-pluriel distingue y rebasa",
        "IX. La portée de l’esthétique du Multiple-pluriel": "IX. El alcance de la esthétique del Multiple-pluriel",
        "X. Proposition de définition du concept": "X. Propuesta de definición del concepto",
        "XI. Inscription dans le lexique et le champ posœnnoïal": "XI. Inscripción en el léxico y en el campo posœnnoïal",
        "Conclusion": "Conclusión"
      },
      "h2": {
        "1. Du sentir à la forme sensible": "1. Del sentir a la forma sensible",
        "2. Le retour posœnnoïal à l’aísthêsis": "2. El retorno posœnnoïal a la aísthêsis",
        "3. Première conséquence conceptuelle": "3. Primera consecuencia conceptual",
        "1. Le multiple comme plissement": "1. Lo multiple como pliegue",
        "2. Le multiple comme densité stratifiée": "2. Lo multiple como densidad estratificada",
        "3. Le multiple comme réserve opérative": "3. Lo multiple como reserva operativa",
        "1. De la grammaire à l’ontologie des présences": "1. De la gramática a la ontología de las presencias",
        "2. Le pluriel comme irréductibilité des voix": "2. Lo plural como irreductibilidad de las voces",
        "3. Le pluriel comme mode d’habitation": "3. Lo plural como modo de habitar",
        "1. Pourquoi l’association des deux termes devient nécessaire": "1. Por qué la asociación de los dos términos se vuelve necesaria",
        "2. Le trait d’union comme opération": "2. El guion como operación",
        "3. Une formulation de travail": "3. Una formulación de trabajo",
        "1. RéZonans : le liage vibratoire du champ": "1. RéZonans: el enlace vibratorio del campo",
        "2. Illusion : la perception du Multiple-pluriel": "2. Illusion: la percepción del Multiple-pluriel",
        "3. Aliœvolution : le rôle de l’altérité": "3. Aliœvolution: el papel de la alteridad",
        "4. Péroptissimisme : la tension constructive": "4. Péroptissimisme: la tensión constructiva",
        "5. L’Addition synchrêtique : l’organe de composition": "5. Addition synchrêtique: el órgano de composición",
        "6. Superposition de perspectives : la polyfocalité": "6. Superposition de perspectives: la polifocalidad",
        "7. Instantané multiple : la polytemporalité": "7. Instantané multiple: la politemporalidad",
        "8. Sujet pluriel : l’architecture intérieure du concept": "8. Sujet pluriel: la arquitectura interior del concepto",
        "9. Les Modalités opératives : la vie du Multiple-pluriel": "9. Modalités opératives: la vida del Multiple-pluriel",
        "1. Une esthétique de la zone de contact": "1. Una esthétique de la zona de contacto",
        "2. « Renaissance » : apparition, fracture, remontée du sensible": "2. « Renaissance »: aparición, fractura y remontada de lo sensible",
        "3. Les « Corps et décors » : identité en voie d’émergence": "3. « Corps et décors »: identidad en vía de emergencia",
        "4. « Méfyans » : la syntaxe de l’entrelacs": "4. « Méfyans »: la sintaxis del entrelazamiento",
        "5. « Synchét’Isme » : condensation et orchestration": "5. « Synchét’Isme »: condensación y orquestación",
        "6. « Upheaval » : le foyer de bascule": "6. « Upheaval »: el foco de basculación",
        "1. Davantage qu’une diversité": "1. Más que una diversidad",
        "2. Davantage qu’un éclectisme": "2. Más que un eclecticismo",
        "3. Davantage qu’un syncrétisme fusionnel": "3. Más que un sincretismo fusional",
        "4. Davantage qu’une fragmentation postmoderne": "4. Más que una fragmentación posmoderna",
        "5. Davantage qu’une multiplicité optique": "5. Más que una multiplicidad óptica",
        "6. En résonance avec le Tout-Monde et le spiralisme, dans une orientation propre": "6. En resonancia con el Tout-Monde y el espiralismo, con una orientación propia",
        "1. Portée plastique": "1. Alcance plástico",
        "2. Portée perceptive": "2. Alcance perceptivo",
        "3. Portée anthropologique": "3. Alcance antropológico",
        "4. Portée épistémologique": "4. Alcance epistemológico",
        "5. Portée philosophique": "5. Alcance filosófico",
        "6. Portée politique et éthique": "6. Alcance político y ético",
        "7. Portée spirituelle et vibratoire": "7. Alcance espiritual y vibratorio",
        "1. Formulation développée": "1. Formulación desarrollada",
        "2. Formulation posœnnoïale resserrée": "2. Formulación posœnnoïale concentrada",
        "3. Formule brève à destination du lexique": "3. Fórmula breve para el léxico",
        "Repère terminologique final": "Referencia terminológica final"
      }
    }
  },
  "chip_images": [
    SUPERPOSITION_PERSPECTIVES_IMG_URL,
    SUJET_PLURIEL_URL,
    ADDITION_SYNCHRETIQUE_URL,
    INSTANTANE_MULTIPLE_URL
  ]
};

  var TERM_URLS = {
    "Le Posœnnoïsme": "https://goodyart.store/pages/posoennoisme",
    "Posœnnoïsme": "https://goodyart.store/pages/posoennoisme",
    "Posœnnoïa": "https://goodyart.store/pages/posoennoia",

    "Piliers": "https://goodyart.store/pages/piliers",
    "Outils": "https://goodyart.store/pages/outils",
    "Engrenage posœnnoïaque": "https://goodyart.store/pages/engrenages",
    "Engrenage posœnnoïque": "https://goodyart.store/pages/engrenages",
    "Engrenages posœnnoïaux": "https://goodyart.store/pages/engrenages",
    "Organon posœnnoïal": "https://goodyart.store/pages/organon-posoennoial",
    "RéZonans": "https://goodyart.store/pages/rezonans",
    "Péroptissimisme": "https://goodyart.store/pages/peroptissimisme",
    "Illusion": "https://goodyart.store/pages/illusion",
    "Aliœvolution": "https://goodyart.store/pages/alioevolution",
    "Addition synchrêtique": "https://goodyart.store/pages/addition-synchetique",
    "Superposition de perspectives": "https://goodyart.store/pages/superposition-de-perspectives",
    "Instantané multiple": "https://goodyart.store/pages/instantane-multiple",
    "Sujet pluriel": "https://goodyart.store/pages/sujet-pluriel",
    "Modalités opératives": "https://goodyart.store/pages/modalites-operatives",

    "Temporalité élargie": "https://goodyart.store/pages/temporalite-elargie",
    "Temporalité éclatée": "https://goodyart.store/pages/temporalite-eclatee",
    "Stratification d’expériences": "https://goodyart.store/pages/stratification-dexperience",
    "Conscience vibratoire": "https://goodyart.store/pages/conscience-vibratoire",
    "Adaptabilité critique": "https://goodyart.store/pages/adaptabilite-critique",
    "Identité évolutive": "https://goodyart.store/pages/identite-evolutive",
    "Expérience fragmentée": "https://goodyart.store/pages/experience-fragmentee",
    "Exploration de l’inconnu": "https://goodyart.store/pages/exploration-de-linconnu",
    "Katûvýs": "https://goodyart.store/pages/katuvys",
    "Katûvýsissence": "https://goodyart.store/pages/katuvysissence",
    "Anamnésis": LEXICON_FALLBACK_URL + "#anamnésis",
    "Posœnnoïamie": "https://goodyart.store/pages/posoennoiamie",
    "Posœnnomia": "https://goodyart.store/pages/posoennomia",
    "Peindre la ligne, dessiner la couleur": "https://goodyart.store/pages/peindre-la-ligne",
    "Painting the line, drawing color": "https://goodyart.store/pages/peindre-la-ligne",
    "Pintar la línea, dibujar el color": "https://goodyart.store/pages/peindre-la-ligne"
  };

  var LEXICON_TERMS = Object.keys(TERM_URLS).sort(function(a,b){ return b.length - a.length; });

  function translateH1(lang, titleFr){
    if (lang === "fr") return titleFr;
    return (PAGE_DATA.title_maps[lang] && PAGE_DATA.title_maps[lang].h1[titleFr]) || titleFr;
  }
  function translateH2(lang, titleFr){
    if (lang === "fr") return titleFr;
    return (PAGE_DATA.title_maps[lang] && PAGE_DATA.title_maps[lang].h2[titleFr]) || titleFr;
  }
  function setHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.innerHTML = html;
  }
  function setText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.textContent = txt;
  }
  function setImg(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) {
      el.src = src || "";
      el.alt = alt || "";
    }
  }

  function paragraphHTML(item){
    var txt = clampStr(item.text);
    var safe = txt
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    if (item.style === "Caption Custom") return '<p class="po-caption">' + safe + '</p>';
    if (item.style === "Small Custom") return '<p class="po-small">' + safe + '</p>';
    if (item.style === "Normal") return '<p class="po-marker">' + safe + '</p>';
    return '<p>' + safe + '</p>';
  }

  function sectionMarker(section, index){
    if (section.title_fr === "Préambule méthodologique") return "P";
    var m = section.title_fr.match(/^([IVXLC]+)\./);
    if (m) return m[1];
    return String(index + 1);
  }

  function renderSummary(lang){
    var items = PAGE_DATA.sections.map(function(section, index){
      var id = slugify(section.title_fr);
      return '<a class="po-toc-link" href="#' + id + '">' +
        '<span class="po-toc-link__num">' + sectionMarker(section, index) + '</span>' +
        '<span class="po-toc-link__txt">' + translateH1(lang, section.title_fr) + '</span>' +
      '</a>';
    }).join("");
    return items;
  }

  function renderChips(lang){
    var chips = PAGE_DATA.ui[lang].chips;
    var imgs = [
      safeImageUrl(SUPERPOSITION_PERSPECTIVES_IMG_URL, 'Superposition'),
      safeImageUrl(SUJET_PLURIEL_URL, 'Sujet pluriel'),
      safeImageUrl(ADDITION_SYNCHRETIQUE_URL, 'Addition'),
      safeImageUrl(INSTANTANE_MULTIPLE_URL, 'Instantané')
    ];
    return chips.map(function(chip, index){
      var imgObj = imgs[index] || safeImageUrl('', chip.label);
      return '' +
      '<a class="po-axis-chipblock" href="' + chip.href + '">' +
        '<span class="po-axis-chip">' + chip.label + '</span>' +
        '<div class="po-axis-chip__media" aria-hidden="true">' +
          '<img class="po-axis-chip__img" src="' + imgObj.src + '" data-po-fallback-src="' + imgObj.fallback + '" alt="' + chip.label.replace(/"/g, "&quot;") + '" loading="lazy" decoding="async" />' +
        '</div>' +
      '</a>';
    }).join("");
  }

  function renderGallery(lang){
    var ui = PAGE_DATA.ui[lang];
    var cards = PAGE_DATA.gallery.map(function(item, idx){
      return '' +
      '<figure class="po-gallery-card">' +
        '<button class="po-gallery-open" type="button" data-po-lightbox-src="' + item.img + '" data-po-lightbox-title="' + item.title.replace(/"/g, "&quot;") + '">' +
          '<img src="' + item.img + '" alt="' + item.title.replace(/"/g, "&quot;") + '" loading="lazy" decoding="async" />' +
        '</button>' +
        '<figcaption>' + item.title + '</figcaption>' +
      '</figure>';
    }).join("");
    return '' +
      '<div class="po-gallery-head">' +
        '<h3>' + ui.gallery_title + '</h3>' +
        '<p>' + ui.gallery_intro + '</p>' +
      '</div>' +
      '<p class="po-caption">' + ui.gallery_caption_1 + '</p>' +
      '<div class="po-gallery-grid">' + cards + '</div>' +
      '<p class="po-caption">' + ui.gallery_caption_2 + '</p>';
  }

  function renderOverviewAudio(lang){
    var ui = PAGE_DATA.ui[lang];
    return renderAudioButton(ui.audio_listen_overview || ui.audio_listen_block, ui.audio_stop, 'overview', -1);
  }

  function renderQuoteAudio(lang){
    var ui = PAGE_DATA.ui[lang];
    return renderAudioButton(ui.audio_listen_quote || ui.audio_listen_block, ui.audio_stop, 'quote', -1);
  }

  function renderArticle2001Trigger(lang){
    var data = ARTICLE_2001[lang] || ARTICLE_2001.fr;
    return '' +
      '<div class="po-article2001-intro" data-po-article2001-block>' +
        '<button class="po-article2001-trigger" type="button" data-po-article2001-open aria-label="' + escapeAttr(data.open_label) + '">' +
          '<img class="po-article2001-trigger__img" src="' + ARTICLE_2001_IMG_URL + '" alt="' + escapeAttr(data.image_alt) + '" loading="lazy" decoding="async" />' +
          '<span class="po-article2001-trigger__caption">' + data.trigger_label + '</span>' +
        '</button>' +
      '</div>';
  }

  function renderArticle2001Audio(lang){
    var ui = PAGE_DATA.ui[lang] || PAGE_DATA.ui.fr || {};
    var labels = {
      fr: "Écouter l’article",
      en: "Listen to the article",
      es: "Escuchar el artículo"
    };
    return '<div class="po-article2001-modal__audio">' +
      renderAudioButton(labels[lang] || labels.fr, ui.audio_stop || "Arrêter", 'article2001', -1) +
    '</div>';
  }

  function renderArticle2001Modal(lang){
    var data = ARTICLE_2001[lang] || ARTICLE_2001.fr;
    var paras = (data.paras || []).map(function(txt){
      return '<p>' + escapeHTML(txt) + '</p>';
    }).join('');
    return '' +
      '<div class="po-article2001-modal" data-po-article2001-modal aria-hidden="true" role="dialog" aria-modal="true" aria-labelledby="po-article2001-title">' +
        '<div class="po-article2001-modal__inner" role="document">' +
          '<button class="po-article2001-modal__close" type="button" data-po-article2001-close aria-label="' + escapeAttr(data.close_label) + '">×</button>' +
          '<p class="po-article2001-modal__eyebrow">' + escapeHTML(data.modal_title) + '</p>' +
          '<h4 id="po-article2001-title">' + escapeHTML(data.article_title) + '</h4>' +
          '<p class="po-article2001-modal__source">' + escapeHTML(data.source) + '</p>' +
          renderArticle2001Audio(lang) +
          '<div class="po-article2001-modal__body">' + paras + '</div>' +
        '</div>' +
      '</div>';
  }

  function renderHistoricalIntro(lang){
    var ui = PAGE_DATA.ui[lang];
    var data = PAGE_DATA.historical_intro || {};
    var paras = (data.paras || []).map(function(p){
      return paragraphHTML(p);
    }).join("");
    return '' +
      '<div class="po-historical-intro__head">' +
        '<h3>' + (ui.historical_intro_title || data.title_fr || '') + '</h3>' +
        renderAudioButton(ui.audio_listen_intro || ui.audio_listen_block, ui.audio_stop, 'historical', -1) +
      '</div>' +
      '<div class="po-historical-intro__body">' + paras + renderArticle2001Trigger(lang) + '</div>' +
      renderArticle2001Modal(lang);
  }

  function renderGeneralAudio(lang){
    var ui = PAGE_DATA.ui[lang];
    return renderAudioButton(ui.audio_toggle, ui.audio_stop, 'general', -1);
  }

  function escapeHTML(txt){
    return clampStr(txt)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function escapeAttr(txt){
    return clampStr(txt)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function renderDocImages(images){
    if (!Array.isArray(images) || !images.length) return "";
    return '<div class="po-doc-image-grid">' + images.map(function(item){
      var title = clampStr(item.title);
      var img = clampStr(item.img);
      return '' +
        '<figure class="po-doc-image-card">' +
          '<img src="' + escapeAttr(img) + '" alt="' + escapeAttr(title) + '" loading="lazy" decoding="async" />' +
          '<figcaption>' + title + '</figcaption>' +
        '</figure>';
    }).join("") + '</div>';
  }

  function renderAudioButton(labelPlay, labelStop, kind, sectionIndex, subIndex){
    var attrs = [
      'class="po-audio-inline-btn"',
      'type="button"',
      'data-po-audio-inline="toggle"',
      'data-po-audio-kind="' + kind + '"',
      'data-po-section-index="' + sectionIndex + '"',
      'data-po-label-play="' + escapeAttr(labelPlay) + '"',
      'data-po-label-stop="' + escapeAttr(labelStop) + '"',
      'aria-pressed="false"'
    ];
    if (typeof subIndex === "number") attrs.push('data-po-subsection-index="' + subIndex + '"');
    return '' +
      '<div class="po-audio-inline" role="group" aria-label="' + escapeAttr(labelPlay) + '">' +
        '<button ' + attrs.join(' ') + '>' +
          '<span class="po-audio-inline__icon" aria-hidden="true">⏵</span>' +
          '<span class="po-audio-inline__label" data-po-audio-label>' + labelPlay + '</span>' +
        '</button>' +
        '<div class="po-audio-inline__status" data-po-audio-status aria-live="polite"></div>' +
      '</div>';
  }

  function renderSection(lang, section, sectionIndex){
    var ui = PAGE_DATA.ui[lang];
    var id = slugify(section.title_fr);
    var html = '<section class="po-doc-section" id="' + id + '">' +
      '<div class="po-doc-section__head">' +
        '<h2>' + translateH1(lang, section.title_fr) + '</h2>' +
        renderAudioButton(ui.audio_listen_section, ui.audio_stop, 'section', sectionIndex) +
      '</div>';
    if (section.intro && section.intro.length){
      html += '<div class="po-doc-section__intro">';
      section.intro.forEach(function(p){ html += paragraphHTML(p); });
      html += '</div>';
    }
    if (section.subsections && section.subsections.length){
      html += '<div class="po-doc-subsections">';
      section.subsections.forEach(function(sub, subIndex){
        html += '<article class="po-doc-subsection">' +
          '<div class="po-doc-subsection__head">' +
            '<h3>' + translateH2(lang, sub.title_fr) + '</h3>' +
            renderAudioButton(ui.audio_listen_block, ui.audio_stop, 'subsection', sectionIndex, subIndex) +
          '</div>' +
          renderDocImages(sub.images) +
          '<div class="po-doc-subsection__body">';
        sub.paras.forEach(function(p){ html += paragraphHTML(p); });
        html += '</div></article>';
      });
      html += '</div>';
    }
    html += '</section>';
    return html;
  }

  function renderArticle(lang){
    var ui = PAGE_DATA.ui[lang];
    var notice = ui.body_notice ? '<div class="po-body-mode"><span>' + ui.body_preserved_label + '</span><strong>' + ui.body_notice + '</strong></div>' : '';
    return notice + PAGE_DATA.sections.map(function(section, sectionIndex){ return renderSection(lang, section, sectionIndex); }).join("");
  }

  function walkTextNodes(root, callback){
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var parent = node.parentNode;
        if (!parent) return NodeFilter.FILTER_REJECT;
        var tag = parent.nodeName.toLowerCase();
        if (/^(script|style|textarea|code|pre)$/i.test(tag)) return NodeFilter.FILTER_REJECT;
        if (parent.closest("a.po-lex-term, .po-langbar, .po-axis-chip")) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(callback);
  }

  function applyLexiconLinks(root){
    if (!root) return;
    var escaped = LEXICON_TERMS.map(function(term){
      return term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    });
    var re = new RegExp("(" + escaped.join("|") + ")", "g");
    walkTextNodes(root, function(node){
      if (!re.test(node.nodeValue)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0;
      node.nodeValue.replace(re, function(match, term, offset){
        if (offset > last) frag.appendChild(document.createTextNode(node.nodeValue.slice(last, offset)));
        var a = document.createElement("a");
        a.className = "po-lex-term notranslate";
        a.setAttribute("translate", "no");
        a.href = TERM_URLS[match] || (LEXICON_FALLBACK_URL + "#" + slugify(match));
        a.textContent = match;
        frag.appendChild(a);
        last = offset + match.length;
      });
      if (last < node.nodeValue.length) frag.appendChild(document.createTextNode(node.nodeValue.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function applyImageFallbacks(root){
    root.querySelectorAll('img[data-po-fallback-src]').forEach(function(img){
      if (img.__poFallbackBound) return;
      img.addEventListener('error', function(){
        var fallback = img.getAttribute('data-po-fallback-src');
        if (fallback && img.src !== fallback) img.src = fallback;
      });
      img.__poFallbackBound = true;
    });
  }

  function bindLangButtons(root, lang){
    var buttons = root.querySelectorAll("[data-po-lang]");
    buttons.forEach(function(btn){
      btn.classList.toggle("is-active", btn.getAttribute("data-po-lang") === lang);
      btn.setAttribute("aria-pressed", btn.classList.contains("is-active") ? "true" : "false");
    });
  }

  function bindArticle2001Modal(root){
    var opener = root.querySelector('[data-po-article2001-open]');
    var overlay = root.querySelector('[data-po-article2001-modal]');
    if (!opener || !overlay) return;

    /* Fenêtre flottante 2001 : placée dans <body> pour éviter les conflits
       de couches, d'overflow ou de stacking context du bloc Shopify. */
    try{
      document.querySelectorAll('[data-po-article2001-body-modal="true"]').forEach(function(oldOverlay){
        if (oldOverlay !== overlay) oldOverlay.remove();
      });
      overlay.setAttribute('data-po-article2001-body-modal', 'true');
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    }catch(e){}

    function open(){
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('po-article2001-open');
      try{
        var panel = overlay.querySelector('.po-article2001-modal__inner');
        overlay.style.display = 'flex';
        overlay.style.alignItems = 'center';
        overlay.style.justifyContent = 'center';
        overlay.style.visibility = 'visible';
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'auto';
        if (panel){
          panel.style.display = 'block';
          panel.style.visibility = 'visible';
          panel.style.opacity = '1';
          panel.style.pointerEvents = 'auto';
        }
      }catch(e){}
    }

    function close(){
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('po-article2001-open');
      try{ overlay.style.display = ''; }catch(e){}
    }

    if (!opener.__poArticle2001Bound){
      opener.addEventListener('click', open);
      opener.__poArticle2001Bound = true;
    }
    overlay.querySelectorAll('[data-po-article2001-close]').forEach(function(btn){
      if (btn.__poArticle2001Bound) return;
      btn.addEventListener('click', close);
      btn.__poArticle2001Bound = true;
    });
    if (!overlay.__poArticle2001OverlayBound){
      overlay.addEventListener('click', function(ev){
        if (ev.target === overlay) close();
      });
      overlay.__poArticle2001OverlayBound = true;
    }

    root.__poArticle2001Close = close;
    if (!root.__poArticle2001EscBound){
      document.addEventListener('keydown', function(ev){
        if (ev.key === 'Escape' && root.__poArticle2001Close) root.__poArticle2001Close();
      });
      root.__poArticle2001EscBound = true;
    }
  }

  function bindLightbox(root){
    var overlay = root.querySelector(".po-lightbox");
    var img = overlay.querySelector("img");
    var cap = overlay.querySelector(".po-lightbox__caption");
    function close(){
      overlay.classList.remove("is-open");
      document.body.classList.remove("po-lightbox-open");
    }
    if (!overlay.__poBound){
      overlay.querySelectorAll("[data-po-lightbox-close]").forEach(function(btn){
        btn.addEventListener("click", close);
      });
      overlay.addEventListener("click", function(ev){
        if (ev.target === overlay) close();
      });
      document.addEventListener("keydown", function(ev){
        if (ev.key === "Escape") close();
      });
      overlay.__poBound = true;
    }
    root.querySelectorAll("[data-po-lightbox-src]").forEach(function(btn){
      if (btn.__poBound) return;
      btn.addEventListener("click", function(){
        img.src = btn.getAttribute("data-po-lightbox-src");
        img.alt = btn.getAttribute("data-po-lightbox-title") || "";
        cap.textContent = btn.getAttribute("data-po-lightbox-title") || "";
        overlay.classList.add("is-open");
        document.body.classList.add("po-lightbox-open");
      });
      btn.__poBound = true;
    });
  }

  function revealNewNodes(root){
    root.querySelectorAll(".po-doc-section, .po-gallery-card, .po-toc-link").forEach(function(el){
      el.classList.add("is-visible");
      if (root.__poObserver) root.__poObserver.observe(el);
    });
  }

  // --- LOGIQUE AUDIO PAR BLOC ---
  var synth = window.speechSynthesis || null;
  var activeAudio = null;
  var audioRunId = 0;

  function resetInlineAudioUI(root){
    if (!root) return;
    root.querySelectorAll('[data-po-audio-inline="toggle"]').forEach(function(btn){
      btn.classList.remove('is-playing');
      btn.setAttribute('aria-pressed', 'false');
      var icon = btn.querySelector('.po-audio-inline__icon');
      var label = btn.querySelector('[data-po-audio-label]');
      var status = btn.parentNode ? btn.parentNode.querySelector('[data-po-audio-status]') : null;
      if (icon) icon.textContent = '⏵';
      if (label) label.textContent = btn.getAttribute('data-po-label-play') || '';
      if (status) status.textContent = '';
    });
  }

  function setInlineAudioState(btn, isPlaying, statusText){
    if (!btn) return;
    var icon = btn.querySelector('.po-audio-inline__icon');
    var label = btn.querySelector('[data-po-audio-label]');
    var status = btn.parentNode ? btn.parentNode.querySelector('[data-po-audio-status]') : null;
    btn.classList.toggle('is-playing', !!isPlaying);
    btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    if (icon) icon.textContent = isPlaying ? '⏸' : '⏵';
    if (label) label.textContent = isPlaying ? (btn.getAttribute('data-po-label-stop') || '') : (btn.getAttribute('data-po-label-play') || '');
    if (status) status.textContent = statusText || '';
  }

  function splitForSpeech(text, maxLen){
    var cleaned = clampStr(text).replace(/\s+/g, ' ').trim();
    if (!cleaned) return [];
    if (cleaned.length <= maxLen) return [cleaned];

    var sentences = cleaned.match(/[^.!?;:]+[.!?;:]*/g) || [cleaned];
    var chunks = [];
    var current = '';

    function pushCurrent(){
      if (current) {
        chunks.push(current.trim());
        current = '';
      }
    }

    sentences.forEach(function(sentence){
      var part = clampStr(sentence).replace(/\s+/g, ' ').trim();
      if (!part) return;

      if (!current) {
        if (part.length <= maxLen) {
          current = part;
          return;
        }
      } else if ((current + ' ' + part).length <= maxLen) {
        current += ' ' + part;
        return;
      } else {
        pushCurrent();
      }

      if (part.length <= maxLen) {
        current = part;
        return;
      }

      var segments = part.split(/,\s+/);
      var temp = '';
      segments.forEach(function(segment){
        var seg = clampStr(segment).trim();
        if (!seg) return;

        if (!temp) {
          if (seg.length <= maxLen) {
            temp = seg;
          } else {
            var words = seg.split(/\s+/);
            var wordLine = '';
            words.forEach(function(word){
              if (!wordLine) {
                wordLine = word;
              } else if ((wordLine + ' ' + word).length <= maxLen) {
                wordLine += ' ' + word;
              } else {
                chunks.push(wordLine.trim());
                wordLine = word;
              }
            });
            if (wordLine) chunks.push(wordLine.trim());
          }
        } else if ((temp + ', ' + seg).length <= maxLen) {
          temp += ', ' + seg;
        } else {
          chunks.push(temp.trim());
          temp = seg;
        }
      });
      if (temp) current = temp;
    });

    pushCurrent();
    return chunks;
  }

  function getSectionAudioParts(section){
    var parts = [section.title_fr];
    (section.intro || []).forEach(function(p){
      if (p && p.style !== 'Normal') parts.push(p.text);
    });
    (section.subsections || []).forEach(function(sub){
      parts.push(sub.title_fr);
      (sub.paras || []).forEach(function(p){
        if (p && p.style !== 'Normal') parts.push(p.text);
      });
    });
    return parts;
  }

  function getSubsectionAudioParts(sub){
    var parts = [sub.title_fr];
    (sub.paras || []).forEach(function(p){
      if (p && p.style !== 'Normal') parts.push(p.text);
    });
    return parts;
  }

  function getOverviewAudioParts(lang){
    var ui = PAGE_DATA.ui[lang] || PAGE_DATA.ui.fr || {};
    var parts = [];
    if (ui.overview_title) parts.push(ui.overview_title);
    if (PAGE_DATA.front && PAGE_DATA.front.title) parts.push(PAGE_DATA.front.title);
    if (PAGE_DATA.front && PAGE_DATA.front.subtitle) parts.push(PAGE_DATA.front.subtitle);
    if (ui.def_short) parts.push(ui.def_short);
    if (ui.chips && ui.chips.length){
      parts.push('Repères liés : ' + ui.chips.map(function(chip){ return chip.label; }).join(', ') + '.');
    }
    return parts;
  }

  function getQuoteAudioParts(){
    var ui = PAGE_DATA.ui.fr || {};
    var parts = [];
    if (ui.quote_title) parts.push(ui.quote_title);
    if (PAGE_DATA.quote) parts.push(PAGE_DATA.quote);
    if (PAGE_DATA.quote_source) parts.push(PAGE_DATA.quote_source);
    return parts;
  }

  function getHistoricalIntroAudioParts(){
    var data = PAGE_DATA.historical_intro || {};
    var parts = [];
    if (data.title_fr) parts.push(data.title_fr);
    (data.paras || []).forEach(function(p){
      if (p && p.style !== 'Normal') parts.push(p.text);
    });
    return parts;
  }

  function getArticle2001AudioParts(lang){
    var data = ARTICLE_2001[lang] || ARTICLE_2001.fr;
    var parts = [];
    if (data.article_title) parts.push(data.article_title);
    if (data.source) parts.push(data.source);
    (data.paras || []).forEach(function(txt){
      if (txt) parts.push(txt);
    });
    return parts;
  }

  function getGeneralAudioParts(){
    var ui = PAGE_DATA.ui.fr || {};
    var parts = [];
    getOverviewAudioParts('fr').forEach(function(part){ parts.push(part); });
    getQuoteAudioParts().forEach(function(part){ parts.push(part); });
    if (ui.gallery_title) parts.push(ui.gallery_title);
    if (ui.gallery_intro) parts.push(ui.gallery_intro);
    if (ui.gallery_caption_1) parts.push(ui.gallery_caption_1);
    if (ui.gallery_caption_2) parts.push(ui.gallery_caption_2);
    getHistoricalIntroAudioParts().forEach(function(part){ parts.push(part); });
    return parts;
  }

  function getAudioPartsForButton(root, btn){
    var kind = btn.getAttribute('data-po-audio-kind');
    if (kind === 'general') return getGeneralAudioParts();
    if (kind === 'overview') return getOverviewAudioParts(root.__poLang || 'fr');
    if (kind === 'quote') return getQuoteAudioParts();
    if (kind === 'historical') return getHistoricalIntroAudioParts();
    if (kind === 'article2001') return getArticle2001AudioParts(root.__poLang || 'fr');

    var sectionIndex = parseInt(btn.getAttribute('data-po-section-index'), 10);
    var section = PAGE_DATA.sections[sectionIndex];
    if (!section) return [];
    if (kind === 'subsection'){
      var subIndex = parseInt(btn.getAttribute('data-po-subsection-index'), 10);
      var sub = (section.subsections || [])[subIndex];
      return sub ? getSubsectionAudioParts(sub) : [];
    }
    return getSectionAudioParts(section);
  }

  function findSectionButton(root, sectionIndex){
    return root.querySelector('[data-po-audio-inline="toggle"][data-po-audio-kind="section"][data-po-section-index="' + sectionIndex + '"]');
  }

  function findSubsectionButton(root, sectionIndex, subIndex){
    return root.querySelector('[data-po-audio-inline="toggle"][data-po-audio-kind="subsection"][data-po-section-index="' + sectionIndex + '"][data-po-subsection-index="' + subIndex + '"]');
  }

  function findOverviewButton(root){
    return root.querySelector('[data-po-audio-inline="toggle"][data-po-audio-kind="overview"]');
  }

  function findQuoteButton(root){
    return root.querySelector('[data-po-audio-inline="toggle"][data-po-audio-kind="quote"]');
  }

  function findHistoricalButton(root){
    return root.querySelector('[data-po-audio-inline="toggle"][data-po-audio-kind="historical"]');
  }

  function getNextAudioButton(root, btn){
    if (!btn) return null;
    var kind = btn.getAttribute('data-po-audio-kind');
    var sectionIndex = parseInt(btn.getAttribute('data-po-section-index'), 10);
    if (isNaN(sectionIndex)) return null;

    if (kind === 'general'){
      return findSectionButton(root, 0);
    }

    if (kind === 'overview'){
      return findQuoteButton(root) || findHistoricalButton(root) || findSectionButton(root, 0);
    }

    if (kind === 'quote'){
      return findHistoricalButton(root) || findSectionButton(root, 0);
    }

    if (kind === 'historical'){
      return findSectionButton(root, 0);
    }

    if (kind === 'section'){
      return findSectionButton(root, sectionIndex + 1);
    }

    if (kind === 'subsection'){
      var subIndex = parseInt(btn.getAttribute('data-po-subsection-index'), 10);
      if (isNaN(subIndex)) return null;
      var section = PAGE_DATA.sections[sectionIndex];
      var subCount = section && section.subsections ? section.subsections.length : 0;
      if (subIndex + 1 < subCount){
        return findSubsectionButton(root, sectionIndex, subIndex + 1);
      }
      return findSectionButton(root, sectionIndex + 1);
    }

    return null;
  }

  function stopInlineAudio(root, preserveUI){
    audioRunId += 1;
    if (synth && synth.speaking) synth.cancel();
    activeAudio = null;
    if (!preserveUI) resetInlineAudioUI(root);
  }

  function speakNextInlineChunk(root){
    if (!activeAudio || !synth) return;
    if (activeAudio.index >= activeAudio.queue.length){
      var btnDone = activeAudio.button;
      var langDone = root.__poLang || 'fr';
      var uiDone = PAGE_DATA.ui[langDone];
      var nextBtn = activeAudio.autoplay ? getNextAudioButton(root, btnDone) : null;
      setInlineAudioState(btnDone, false, nextBtn ? uiDone.audio_status_playing : uiDone.audio_status_idle);
      activeAudio = null;
      if (nextBtn) {
        playInlineAudio(root, nextBtn, { chained: true });
      }
      return;
    }

    var utterance = new SpeechSynthesisUtterance(activeAudio.queue[activeAudio.index]);
    var runId = activeAudio.runId;
    activeAudio.utterance = utterance;
    utterance.lang = activeAudio.speechLang || 'fr-FR';
    utterance.rate = 0.95;

    utterance.onstart = function(){
      if (!activeAudio || activeAudio.runId !== runId) return;
      var lang = root.__poLang || 'fr';
      var ui = PAGE_DATA.ui[lang];
      setInlineAudioState(activeAudio.button, true, ui.audio_status_playing);
    };

    utterance.onend = function(){
      if (!activeAudio || activeAudio.runId !== runId) return;
      activeAudio.index += 1;
      speakNextInlineChunk(root);
    };

    utterance.onerror = function(){
      if (!activeAudio || activeAudio.runId !== runId) return;
      var lang = root.__poLang || 'fr';
      var ui = PAGE_DATA.ui[lang];
      setInlineAudioState(activeAudio.button, false, ui.audio_status_stopped);
      activeAudio = null;
    };

    synth.speak(utterance);
  }

  function getSpeechLangForButton(root, btn){
    var kind = btn ? btn.getAttribute('data-po-audio-kind') : '';
    var lang = root.__poLang || 'fr';
    if (kind === 'overview' || kind === 'article2001'){
      if (lang === 'en') return 'en-US';
      if (lang === 'es') return 'es-ES';
    }
    return 'fr-FR';
  }

  function playInlineAudio(root, btn, options){
    if (!synth) return;
    options = options || {};
    stopInlineAudio(root, !!options.chained);
    var parts = getAudioPartsForButton(root, btn);
    var queue = [];
    parts.forEach(function(part){
      splitForSpeech(part, 260).forEach(function(chunk){
        if (chunk) queue.push(chunk);
      });
    });
    if (!queue.length) return;

    audioRunId += 1;
    activeAudio = {
      button: btn,
      queue: queue,
      index: 0,
      utterance: null,
      runId: audioRunId,
      autoplay: true,
      speechLang: getSpeechLangForButton(root, btn)
    };
    speakNextInlineChunk(root);
  }

  function bindInlineAudio(root){
    root.querySelectorAll('[data-po-audio-inline="toggle"]').forEach(function(btn){
      if (btn.__poBound) return;
      btn.addEventListener('click', function(){
        if (activeAudio && activeAudio.button === btn){
          stopInlineAudio(root);
          return;
        }
        playInlineAudio(root, btn);
      });
      btn.__poBound = true;
    });
  }

  function render(root, lang){
    var ui = PAGE_DATA.ui[lang];
    setImg(root, "title_img", TITLE_IMG_URL, PAGE_DATA.front.title);
    setText(root, "title", ui.title);
    setText(root, "subtitle", ui.subtitle);
    setText(root, "doclabel", ui.doclabel);
    setText(root, "author", ui.author);
    setText(root, "rights", ui.rights);
    setText(root, "lang_note", ui.lang_note);
    setText(root, "overview_title", ui.overview_title);
    setHTML(root, "audio_overview", renderOverviewAudio(lang));
    setText(root, "def_short", ui.def_short);
    setText(root, "quote_title", ui.quote_title);
    setHTML(root, "audio_quote", renderQuoteAudio(lang));
    setText(root, "quote_source", PAGE_DATA.quote_source);
    setHTML(root, "quote_text", PAGE_DATA.quote.replace(/\n/g, "<br />"));
    setText(root, "summary_title", ui.summary_title);
    setText(root, "summary_intro", ui.summary_intro);
    setHTML(root, "chips", renderChips(lang));
    setHTML(root, "summary_links", renderSummary(lang));
    setHTML(root, "gallery", renderGallery(lang));
    setHTML(root, "historical_intro", renderHistoricalIntro(lang));
    setHTML(root, "audio_general", "");
    setHTML(root, "article", renderArticle(lang));
    setText(root, "cta_translate", ui.cta_text);
    bindLangButtons(root, lang);
    applyLexiconLinks(root.querySelector(".po-article"));
    applyLexiconLinks(root.querySelector(".po-lex-def-short"));
    applyLexiconLinks(root.querySelector(".po-gallery"));
    applyLexiconLinks(root.querySelector(".po-historical-intro"));
    applyLexiconLinks(root.querySelector(".po-summary"));
    applyLexiconLinks(root.querySelector(".po-axis-quote"));
    applyImageFallbacks(root);
    root.__poLang = lang;
    stopInlineAudio(root);
    bindInlineAudio(root);
    bindArticle2001Modal(root);
    bindLightbox(root);
    revealNewNodes(root);
  }

  function initRoot(root){
    var lang = detectLang();

    if ("IntersectionObserver" in window){
      root.__poObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });
    }

    render(root, lang);

    root.querySelectorAll("[data-po-lang]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var next = normLang(btn.getAttribute("data-po-lang"));
        setStoredLang(next);
        render(root, next);
      });
    });
  }

  function init(){
    document.querySelectorAll('.po-axis-section[data-po-essay="multiple_pluriel"]').forEach(initRoot);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  window.PoEsthetiqueMultiplePlurielFR_EN_ES_20260331 = {
    render: render
  };
})();
